// product card individual element 
if (!customElements.get('product-card')) {
  customElements.define('product-card', class ProductCard extends HTMLElement {
    constructor() {
      super();
      
      this.data = this.querySelector('[type="application/json"]');
      this.variantDataCase = this.dataset.variantShowCase;
      this.dataPrefix = this.dataset.prefix;
      this.elements = {
        priceElem: this.querySelector('[data-request-contents="price"]'),
        priceDup: this.querySelector(`.${this.dataPrefix}price-duplicator`),
        saleTag: this.querySelector('[data-request-contents="sale-tag"]'),
        formElems: this.querySelectorAll('form:not([action*="contact"])'),
        submitFormElem: this.querySelector(`.${this.dataPrefix}form:not([class*="installment"]):not([action*="contact"])`),
        thumbnailGallery: this.querySelector(`.${this.dataPrefix}thumbnail-switcher`),
        loader: this.querySelectorAll(`.${this.dataPrefix}loader`),
        addToCartButton: this.querySelectorAll('button[name="add"]') || this.querySelectorAll('button[type="submit"]'),
        cartInvertoryOrganizer: document.querySelector('cart-inventory-organizer'),
        inCartElem: this.querySelector(`.${this.dataPrefix}in-cart`),
        cartShower: document.querySelector('[data-action="cart-drawer"]'),
        quantityInput: this.querySelector('quantity-input'),
        shareUrlInput: this.querySelector(`.shareUrl`),
        inventory: this.querySelector(`[data-request-contents="inventory"]`),
        sku: this.querySelector(`.${this.dataPrefix}sku`),
        variantsContainer: this.querySelector('product-card-variants'),
        variantColorsContainer: this.querySelector('product-card-colors'),
        pickUpAvailability: this.querySelector(`[data-request-contents="pickup"]`),
        staticGalleryItem: this.querySelector(`.${this.dataPrefix}static-gallery`),
        variantsDrawerOpener: this.querySelectorAll(`.${this.dataPrefix}variants-toggler`),
        variantsDrawer: this.querySelector(`.${this.dataPrefix}variation-drawer`),
        stockBar: this.querySelector(`[data-request-contents="stockbar"]`),
        unitPrice: this.querySelector(`[data-request-contents="unit-price"]`),
        statckedThumbnails: this.querySelectorAll('.product-gallery-thumbnail'),
        bundleCheckCardLabel: this.querySelector('.bundle-check-product'),
        cardInventory: this.querySelector(`[data-request-contents="inventory-card"]`),
        galleryThumbnails: this.querySelector(`.${this.dataPrefix}gallery-thumbnails`),
        errorsContainer: this.querySelector(`.${this.dataPrefix}errors`)
      }
      this.staticSelectors = {
        inputRadio: 'input[type="radio"]',
        option: 'option',
        inputVariantId: 'input[name="id"]',
        selects: 'select',
        scripTag: '[type="application/json"]',
        pickUp: `[data-request-contents="pickup"]`,
        inventory: `[data-request-contents="inventory"]`,
        staticGalleryThumbItem: `.product_gallery-item:not(.product_gallery-item--variant)`,
        staticGalleryVariantItem: '.product_gallery-item--variant',
        price: '[data-request-contents="price"]',
        priceTag: '[data-request-contents="sale-tag"]',
        variantRows: `.${this.dataPrefix}variant-row`,
        priceDuplicator: `.${this.dataPrefix}price-duplicator`,
        stockStatuesBar: '[data-request-contents="stockbar"]',
        unitPricing: '[data-request-contents="unit-price"]',
        inventCard: '[data-request-contents="inventory-card"]',
      }
      
      if(this.elements.variantsDrawerOpener){
        this.elements.variantsDrawerOpener.forEach(element => {
          element.addEventListener('click', this.openVariantDrawer.bind(this, event))
        });
      };
      if(this.elements.variantColorsContainer) this.elements.variantColorsContainer.addEventListener('change', this.onVariantColorChange.bind(this, event));
      if(this.elements.variantsContainer) this.elements.variantsContainer.addEventListener('change', this.onVariantChange.bind(this, event));
      if(this.elements.submitFormElem) this.elements.submitFormElem.addEventListener('submit', this.onsubmitHandler.bind(this));
      if(this.elements.bundleCheckCardLabel) this.elements.bundleCheckCardLabel.addEventListener('click', this.onBundleCheckLabel.bind(this));
    }
    
    connectedCallback(){
      if(!this.data) return;
      this.data = JSON.parse(this.data.textContent);
      if(this.dataset.swatchImages === 'true') this.setSwatchImages();
      initCollapsibleVariantOptions(this);
      // Correct server-rendered availability states: the Liquid snippet anchors
      // availability to admin option order, but we may render options in a different
      // order (e.g. Cover Type shown after Condition even if it is admin option 1).
      // Running these here ensures the initial pill states reflect the actual selection.
      if (this.variantDataCase === 'radio' && this.elements.variantsContainer) {
        this.getSelectedVarintOptions();
        this.selectedVariantData();
        this.updateMedia();
        this.updateVariantStatuses();
      }
      this.initMobileStickySummary();
      this.initDescriptionDisclosure();
      this.initOptionalExtras();
      this.initConsoleBundle();
    }

    initMobileStickySummary() {
      const productRoot = this.closest('.main-product');
      const titleBlock = this.querySelector('.main-product_title-block');
      const priceBlock = this.querySelector('.main-product_price_and_variations-block');

      if (!productRoot || !titleBlock || !priceBlock) return;
      this.mobileStickySummaryRoot = productRoot;
      const isBundleProduct = productRoot.classList.contains('main-product--bundle');
      if (!isBundleProduct) {
        productRoot.classList.remove('main-product--mobile-sticky-summary', 'is-summary-stuck');
        productRoot.style.removeProperty('--rq-mobile-sticky-title-height');
        return;
      }
      let summaryWrapper = this.querySelector('.main-product_mobile-sticky-summary');

      if (isBundleProduct && !summaryWrapper) {
        const summaryTitle = titleBlock.querySelector('.main-product_heading');
        const currentPrice = this.querySelector('[data-bundle-page-price]')?.textContent?.trim() || '';
        summaryWrapper = document.createElement('div');
        summaryWrapper.className = 'main-product_mobile-sticky-summary';
        summaryWrapper.innerHTML = `
          <div class="main-product_mobile-sticky-summary-title" data-mobile-sticky-summary-title>${this.escapeHtml(summaryTitle ? summaryTitle.textContent.trim() : '')}</div>
          <div class="main-product_mobile-sticky-summary-price" data-mobile-sticky-summary-price>${this.escapeHtml(currentPrice)}</div>
        `;
        productRoot.append(summaryWrapper);
      }

      const stickyTarget = titleBlock;

      const updateStickyState = () => {
        const isMobile = window.matchMedia('(max-width: 786px)').matches;
        if (!isMobile) {
          productRoot.classList.remove('is-summary-stuck');
          return;
        }

        const headerOffset = document.body.classList.contains('page-header--fixed')
          ? parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--page-header-height')) || 0
          : 0;
        const stickyTop = stickyTarget.getBoundingClientRect().top;
        productRoot.classList.toggle('is-summary-stuck', stickyTop <= headerOffset + 1);
      };

      const syncStickySummary = () => {
        const isMobile = window.matchMedia('(max-width: 786px)').matches;
        productRoot.classList.toggle('main-product--mobile-sticky-summary', isMobile);

        if (!isMobile) {
          productRoot.style.removeProperty('--rq-mobile-sticky-title-height');
          productRoot.classList.remove('is-summary-stuck');
          return;
        }

        productRoot.style.setProperty('--rq-mobile-sticky-title-height', `${Math.ceil(titleBlock.offsetHeight)}px`);
        updateStickyState();
      };

      syncStickySummary();
      window.addEventListener('resize', syncStickySummary);
      window.addEventListener('scroll', updateStickyState, { passive: true });

      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(syncStickySummary);
        observer.observe(titleBlock);
        this.mobileStickySummaryObserver = observer;
      }

      this.mobileStickySummaryUpdateState = updateStickyState;
    }

    initDescriptionDisclosure() {
      const description = this.querySelector('.main-product_description-block');
      if (!description || description.dataset.descriptionDisclosureBound) return;

      const collapsedHeight = 600;
      const button = document.createElement('button');
      if (!description.id) description.id = `ProductDescription-${this.data?.id || this.dataset.id || Date.now()}`;
      button.type = 'button';
      button.className = 'main-product_description-continue';
      button.textContent = 'Continue reading description';
      button.setAttribute('aria-controls', description.id);
      button.setAttribute('aria-expanded', 'false');
      button.hidden = true;
      description.insertAdjacentElement('afterend', button);

      const syncDisclosure = () => {
        if (description.classList.contains('main-product_description-block--expanded')) return;

        const shouldCollapse = description.scrollHeight > collapsedHeight;
        description.classList.toggle('main-product_description-block--collapsible', shouldCollapse);
        description.classList.toggle('main-product_description-block--collapsed', shouldCollapse);
        button.hidden = !shouldCollapse;
      };

      button.addEventListener('click', () => {
        description.classList.remove('main-product_description-block--collapsed');
        description.classList.add('main-product_description-block--expanded');
        button.hidden = true;
        button.setAttribute('aria-expanded', 'true');
      });

      description.querySelectorAll('img, iframe').forEach((media) => {
        media.addEventListener('load', syncDisclosure, { once: true });
      });

      description.dataset.descriptionDisclosureBound = 'true';
      syncDisclosure();
      window.requestAnimationFrame(syncDisclosure);

      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(syncDisclosure);
        observer.observe(description);
        this.descriptionDisclosureObserver = observer;
      }
    }

    setSwatchImages(){
      const optionsArr = this.data.options;
      if(!optionsArr.includes('Color') && !optionsArr.includes('color') && !optionsArr.includes('Colour') && !optionsArr.includes('colour')) return;
      if(optionsArr.length === 1){
        const containers = [this.querySelector('product-card-variants'), this.querySelector('product-card-colors')];
        containers.forEach(container => {
          const labels = container.querySelectorAll('label');
          labels.forEach((label, index) => {
            label.classList.add('--swatch-image');
            const variant = this.data.variants[index];
            const featuredMedia = variant && variant.featured_media ? variant.featured_media : null;
            if(!featuredMedia) {
              label.style.backgroundImage = "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAATCAYAAACdkl3yAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABdaVRYdFNuaXBNZXRhZGF0YQAAAAAAeyJjbGlwUG9pbnRzIjpbeyJ4IjowLCJ5IjowfSx7IngiOjE4LCJ5IjowfSx7IngiOjE4LCJ5IjoxOX0seyJ4IjowLCJ5IjoxOX1dfetuk4EAAAEmSURBVDhPlZPLkkZADIXT2LGywBPg/dfKE1hT3gDFRllYMXMyf7rCjMt8VS0tlyNCm7Isd1Ls+05xHFOaph/PkWEYqK5r8jyPjDGcDxy+OGwYBCR4B0Q0VuEceIvUsZDu4r+C9tWw2bbNimH/BuTpOlNV1a9h+75PYRgeZgcQW5aFpmnimB62Wdd1F4fYvu+pbVtyXZeTBHQQRRHleW4FhG/hH+WzlXW+1/7D+ghegiKgO/6LRyEgXdzxKIQOrrrQXAqJgF4Y9lVnZhxH+zgkg3me+UzJoMUPGwQBn0UtCL8pioKzdHKSJJRlGd8DEYPtuo6aprG/htQ5CMKpF3x6AbHSJayuYSFJAvKEJ3QNePX577Cd4vK2C43U2Blho0/xW46nf6cv9tXO7HWOFxkAAAAASUVORK5CYII=')";
              label.classList.add('--swatch-placeholder');
              return;
            }
            label.style.backgroundImage = `url(${featuredMedia.preview_image.src})`;
          });
        });
      } else{
        const variants = this.getPairOptions();
        const labels = this.querySelectorAll('product-card-variants .variant-row--pills-color label');
        const colorLabels = this.querySelectorAll('product-card-colors label');
        setImage(labels);
        setImage(colorLabels);

        function setImage(arr){
          arr.forEach((label, index) => {
            label.classList.add('--swatch-image');
            const variant = variants[index];
            const featuredMedia = variant && variant.featured_media ? variant.featured_media : null;
            if(!featuredMedia) {
              label.style.backgroundImage = "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAATCAYAAACdkl3yAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABdaVRYdFNuaXBNZXRhZGF0YQAAAAAAeyJjbGlwUG9pbnRzIjpbeyJ4IjowLCJ5IjowfSx7IngiOjE4LCJ5IjowfSx7IngiOjE4LCJ5IjoxOX0seyJ4IjowLCJ5IjoxOX1dfetuk4EAAAEmSURBVDhPlZPLkkZADIXT2LGywBPg/dfKE1hT3gDFRllYMXMyf7rCjMt8VS0tlyNCm7Isd1Ls+05xHFOaph/PkWEYqK5r8jyPjDGcDxy+OGwYBCR4B0Q0VuEceIvUsZDu4r+C9tWw2bbNimH/BuTpOlNV1a9h+75PYRgeZgcQW5aFpmnimB62Wdd1F4fYvu+pbVtyXZeTBHQQRRHleW4FhG/hH+WzlXW+1/7D+ghegiKgO/6LRyEgXdzxKIQOrrrQXAqJgF4Y9lVnZhxH+zgkg3me+UzJoMUPGwQBn0UtCL8pioKzdHKSJJRlGd8DEYPtuo6aprG/htQ5CMKpF3x6AbHSJayuYSFJAvKEJ3QNePX577Cd4vK2C43U2Blho0/xW46nf6cv9tXO7HWOFxkAAAAASUVORK5CYII=')";
              label.classList.add('--swatch-placeholder');
              return;
            }
            label.style.backgroundImage = `url(${featuredMedia.preview_image.src})`;
          });
        }
      }
    }

    getPairOptions(){
      const rows = this.querySelectorAll(`product-card-variants .variant-row--pills:not(.variant-row--pills-color)`);
      const variantDataRows = Array.from(rows);
      const options = variantDataRows.map((rowSet) => {
        return Array.from(rowSet.querySelectorAll(this.staticSelectors.inputRadio)).find((radio) => radio.checked).value;
      });
      const variants = this.getPairedVariants(options);
      return variants;
    }

    getPairedVariants(optionsToMatch){
      return this.data.variants.filter(variant =>
        optionsToMatch.every(option =>
          variant.options.includes(option)
        )
      );
    }
    
    openVariantDrawer(){
      event.preventDefault();
      const variants = this.querySelector('.product_variation-wrap');
      
      if(this.classList.contains('--drawer-active')){
        variants.removeAttribute('tabindex');
        this.classList.remove('--drawer-active');
      
      } else{
        this.classList.add('--drawer-active');
        variants.setAttribute('tabindex', '-1');
        variants.focus();
      }
    }

    getConsoleBundleConfig() {
      if (this.consoleBundleConfig !== undefined) return this.consoleBundleConfig;
      const configEl = this.querySelector('script[data-console-bundle-config]');
      if (!configEl) {
        this.consoleBundleConfig = null;
        return this.consoleBundleConfig;
      }

      try {
        this.consoleBundleConfig = JSON.parse(configEl.textContent);
      } catch (error) {
        console.error('[RQ] console bundle config parse error', error);
        this.consoleBundleConfig = null;
      }

      return this.consoleBundleConfig;
    }

    hasConsoleBundle() {
      const config = this.getConsoleBundleConfig();
      return !!(config && this.isValidBundleProductConfig(config.console));
    }

    normalizeOptionalAddOnTooltips() {
      const selector = [
        '.rq-console-bundle__optional-addon-card > .rq-console-bundle__whats-this',
        '.rq-optional-extras__card > .rq-console-bundle__whats-this'
      ].join(', ');

      this.querySelectorAll(selector).forEach((tooltip) => {
        const label = tooltip.closest('.rq-console-bundle__optional-addon-option, .rq-optional-extras__option');
        if (!label) return;
        const parent = label.parentElement;

        if (parent && !parent.classList.contains('rq-console-bundle__optional-addon-item')) {
          const wrapper = document.createElement('span');
          wrapper.className = 'rq-console-bundle__optional-addon-item rq-optional-extras__item';
          if (label.classList.contains('rq-console-bundle__extra-item--disabled')) {
            wrapper.classList.add('rq-console-bundle__extra-item--disabled');
          }
          parent.insertBefore(wrapper, label);
          wrapper.append(label);
          wrapper.append(tooltip);
        } else {
          label.insertAdjacentElement('afterend', tooltip);
        }

        tooltip.classList.add('rq-console-bundle__optional-addon-whats-this');
      });
    }

    isValidBundleProductConfig(productConfig) {
      return !!(
        productConfig &&
        String(productConfig.handle || '').trim() &&
        Array.isArray(productConfig.variants) &&
        productConfig.variants.length
      );
    }

    initOptionalExtras() {
      this.normalizeOptionalAddOnTooltips();

      const optionalExtraQtyInputs = this.querySelectorAll('[data-optional-extra-qty-input]');
      const optionalExtraQtySteppers = this.querySelectorAll('[data-optional-extra-qty-stepper]');

      optionalExtraQtyInputs.forEach((optionalExtraQtyInput) => {
        if (!optionalExtraQtyInput || optionalExtraQtyInput.dataset.optionalExtraBound) return;

        this.clampOptionalExtraQuantity(optionalExtraQtyInput);
        this.updateOptionalExtraCardPrice(optionalExtraQtyInput);
        optionalExtraQtyInput.addEventListener('click', (event) => event.stopPropagation());
        optionalExtraQtyInput.addEventListener('mousedown', (event) => event.stopPropagation());
        optionalExtraQtyInput.addEventListener('change', () => {
          this.clampOptionalExtraQuantity(optionalExtraQtyInput);
          this.updateOptionalExtraCardPrice(optionalExtraQtyInput);
          if (this.hasConsoleBundle()) this.updateConsoleBundle();
        });
        optionalExtraQtyInput.addEventListener('input', () => {
          this.updateOptionalExtraCardPrice(optionalExtraQtyInput);
          if (this.hasConsoleBundle()) this.updateConsoleBundle();
        });
        optionalExtraQtyInput.dataset.optionalExtraBound = 'true';
      });

      optionalExtraQtySteppers.forEach((stepper) => {
        if (!stepper || stepper.dataset.optionalExtraBound) return;

        stepper.addEventListener('click', (event) => {
          const button = event.target.closest('[data-optional-extra-qty-decrement], [data-optional-extra-qty-increment]');
          if (!button) return;

          event.preventDefault();
          event.stopPropagation();
          this.stepOptionalExtraQuantity(button);
          if (this.hasConsoleBundle()) this.updateConsoleBundle();
        });
        stepper.addEventListener('mousedown', (event) => event.stopPropagation());
        stepper.dataset.optionalExtraBound = 'true';
      });
    }

    initConsoleBundle() {
      if (!this.hasConsoleBundle()) return;

      const avSelects = this.querySelectorAll('[data-bundle-av-select]');
      const consoleSelects = this.querySelectorAll('[data-bundle-console-select]');
      const powerSelects = this.querySelectorAll('[data-bundle-power-select]');
      const controllerProductSelects = this.querySelectorAll('[data-bundle-controller-product-select]');
      const controllerCountSelects = this.querySelectorAll('[data-bundle-controller-count-select]');
      const controllerAddOnsContainer = this.querySelector('[data-bundle-controller-addons-wrap]');
      const memoryCardSelects = this.querySelectorAll('[data-bundle-memory-card-select]');
      const memoryCardQtyInputs = this.querySelectorAll('[data-bundle-memory-card-qty-input]');
      const batterySelects = this.querySelectorAll('[data-bundle-battery-select]');
      const batteryQtyInputs = this.querySelectorAll('[data-bundle-battery-qty-input]');
      const optionalAddOnSelects = this.querySelectorAll('[data-bundle-optional-addon-select]');
      const optionalExtraSelects = this.querySelectorAll('[data-optional-extra-select]');
      const cleaningCheckboxes = this.querySelectorAll('[data-cleaning-addon]');
      const qtyInput = this.elements.quantityInput ? this.elements.quantityInput.querySelector('input') : null;

      consoleSelects.forEach((consoleSelect) => {
        if (consoleSelect && !consoleSelect.dataset.bundleBound) {
          consoleSelect.addEventListener('change', () => {
            this.renderConsoleBundleConditionOptions(this.getSelectedBundleCondition());
            this.renderConsoleBundleAdvancedOptions();
            this.updateConsoleBundle();
          });
          consoleSelect.dataset.bundleBound = 'true';
        }
      });

      avSelects.forEach((avSelect) => {
        if (avSelect && !avSelect.dataset.bundleBound) {
          avSelect.addEventListener('change', () => this.updateConsoleBundle());
          avSelect.dataset.bundleBound = 'true';
        }
      });

      powerSelects.forEach((powerSelect) => {
        if (powerSelect && !powerSelect.dataset.bundleBound) {
          powerSelect.addEventListener('change', () => this.updateConsoleBundle());
          powerSelect.dataset.bundleBound = 'true';
        }
      });

      controllerProductSelects.forEach((controllerSelect) => {
        if (controllerSelect && !controllerSelect.dataset.bundleBound) {
          controllerSelect.addEventListener('change', () => {
            this.selectDefaultBundleControllerProduct();
            this.updateConsoleBundle();
          });
          controllerSelect.dataset.bundleBound = 'true';
        }
      });

      controllerCountSelects.forEach((countSelect) => {
        if (countSelect && !countSelect.dataset.bundleBound) {
          countSelect.addEventListener('change', () => this.updateConsoleBundle());
          countSelect.dataset.bundleBound = 'true';
        }
      });

      if (controllerAddOnsContainer && !controllerAddOnsContainer.dataset.bundleBound) {
        controllerAddOnsContainer.addEventListener('change', (event) => {
          if (event.target && event.target.matches('[data-bundle-controller-addon-select]')) {
            this.updateConsoleBundle();
          }
        });
        controllerAddOnsContainer.dataset.bundleBound = 'true';
      }

      memoryCardSelects.forEach((memoryCardSelect) => {
        if (memoryCardSelect && !memoryCardSelect.dataset.bundleBound) {
          memoryCardSelect.addEventListener('change', () => {
            const card = memoryCardSelect.closest('[data-bundle-memory-card-option]');
            const qtyInput = card ? card.querySelector('[data-bundle-memory-card-qty-input]') : null;
            if (qtyInput) {
              qtyInput.value = memoryCardSelect.checked ? String(Math.max(this.clampBundleMemoryCardQuantity(qtyInput), 1)) : '0';
              this.clampBundleMemoryCardQuantity(qtyInput);
            }
            this.updateConsoleBundle();
          });
          memoryCardSelect.dataset.bundleBound = 'true';
        }
      });

      memoryCardQtyInputs.forEach((memoryQtyInput) => {
        if (memoryQtyInput && !memoryQtyInput.dataset.bundleBound) {
          this.clampBundleMemoryCardQuantity(memoryQtyInput);
          memoryQtyInput.addEventListener('click', (event) => event.stopPropagation());
          memoryQtyInput.addEventListener('mousedown', (event) => event.stopPropagation());
          memoryQtyInput.addEventListener('change', () => {
            this.clampBundleMemoryCardQuantity(memoryQtyInput);
            this.updateConsoleBundle();
          });
          memoryQtyInput.addEventListener('input', () => {
            this.clampBundleMemoryCardQuantity(memoryQtyInput);
            this.updateConsoleBundle();
          });
          memoryQtyInput.dataset.bundleBound = 'true';
        }
      });

      this.querySelectorAll('[data-bundle-memory-card-qty-stepper]').forEach((stepper) => {
        if (!stepper || stepper.dataset.bundleBound) return;

        stepper.addEventListener('click', (event) => {
          const button = event.target.closest('[data-bundle-memory-card-qty-decrement], [data-bundle-memory-card-qty-increment]');
          if (!button) return;

          event.preventDefault();
          event.stopPropagation();
          this.stepBundleMemoryCardQuantity(button);
          this.updateConsoleBundle();
        });
        stepper.addEventListener('mousedown', (event) => event.stopPropagation());
        stepper.dataset.bundleBound = 'true';
      });

      batterySelects.forEach((batterySelect) => {
        if (batterySelect && !batterySelect.dataset.bundleBound) {
          batterySelect.addEventListener('change', () => {
            const card = batterySelect.closest('[data-bundle-battery-option]');
            const qtyInput = card ? card.querySelector('[data-bundle-battery-qty-input]') : null;
            if (qtyInput) {
              qtyInput.value = batterySelect.checked ? String(Math.max(this.clampBundleBatteryQuantity(qtyInput), 1)) : '0';
              this.clampBundleBatteryQuantity(qtyInput);
            }
            this.updateConsoleBundle();
          });
          batterySelect.dataset.bundleBound = 'true';
        }
      });

      batteryQtyInputs.forEach((batteryQtyInput) => {
        if (batteryQtyInput && !batteryQtyInput.dataset.bundleBound) {
          this.clampBundleBatteryQuantity(batteryQtyInput);
          batteryQtyInput.addEventListener('click', (event) => event.stopPropagation());
          batteryQtyInput.addEventListener('mousedown', (event) => event.stopPropagation());
          batteryQtyInput.addEventListener('change', () => {
            this.clampBundleBatteryQuantity(batteryQtyInput);
            this.updateConsoleBundle();
          });
          batteryQtyInput.addEventListener('input', () => {
            this.clampBundleBatteryQuantity(batteryQtyInput);
            this.updateConsoleBundle();
          });
          batteryQtyInput.dataset.bundleBound = 'true';
        }
      });

      this.querySelectorAll('[data-bundle-battery-qty-stepper]').forEach((stepper) => {
        if (!stepper || stepper.dataset.bundleBound) return;

        stepper.addEventListener('click', (event) => {
          const button = event.target.closest('[data-bundle-battery-qty-decrement], [data-bundle-battery-qty-increment]');
          if (!button) return;

          event.preventDefault();
          event.stopPropagation();
          this.stepBundleBatteryQuantity(button);
          this.updateConsoleBundle();
        });
        stepper.addEventListener('mousedown', (event) => event.stopPropagation());
        stepper.dataset.bundleBound = 'true';
      });

      optionalAddOnSelects.forEach((optionalAddOnSelect) => {
        if (optionalAddOnSelect && !optionalAddOnSelect.dataset.bundleBound) {
          optionalAddOnSelect.addEventListener('change', () => this.updateConsoleBundle());
          optionalAddOnSelect.dataset.bundleBound = 'true';
        }
      });

      optionalExtraSelects.forEach((optionalExtraSelect) => {
        if (optionalExtraSelect && !optionalExtraSelect.dataset.bundleBound) {
          optionalExtraSelect.addEventListener('change', () => this.updateConsoleBundle());
          optionalExtraSelect.dataset.bundleBound = 'true';
        }
      });

      cleaningCheckboxes.forEach((checkbox) => {
        if (checkbox && !checkbox.dataset.bundleBound) {
          checkbox.addEventListener('change', () => this.updateConsoleBundle());
          checkbox.dataset.bundleBound = 'true';
        }
      });

      if (qtyInput && !qtyInput.dataset.bundleBound) {
        qtyInput.addEventListener('change', () => this.updateConsoleBundle());
        qtyInput.dataset.bundleBound = 'true';
      }

      this.updateConsoleBundleConsoleOptions();
      this.selectDefaultBundleConsole();
      this.updateConsoleBundleControllerProductOptions();
      this.selectDefaultBundleControllerProduct();
      this.renderConsoleBundleConditionOptions();
      this.renderConsoleBundleAdvancedOptions();
      this.initConsoleBundleImageZoom();
      this.renderConsoleBundleConsoleAddOnTypeOptions();
      this.getBundleGameConfigs().forEach((_, gameIndex) => {
        this.renderConsoleBundleGameTypeOptions(gameIndex);
        this.renderConsoleBundleGameCoverTypeOptions(gameIndex);
      });
      this.updateConsoleBundle();
    }

    getSelectedQuantity() {
      const qtyInput = this.elements.quantityInput ? this.elements.quantityInput.querySelector('input') : null;
      return Math.max(parseInt(qtyInput && qtyInput.value ? qtyInput.value : '1', 10) || 1, 1);
    }

    getBundleConsoleProducts() {
      const consoleProducts = this.getConsoleBundleConfig()?.consoleProducts;
      if (Array.isArray(consoleProducts) && consoleProducts.length) return consoleProducts;
      const consoleProduct = this.getConsoleBundleConfig()?.console;
      return consoleProduct ? [consoleProduct] : [];
    }

    hasAvailableLooseConsoleVariant(productConfig) {
      if (!productConfig) return false;
      return this.getLooseConsoleVariants(productConfig).some(variant => variant && variant.available);
    }

    getDefaultBundleConsoleProduct() {
      const consoleProducts = this.getBundleConsoleProducts();
      return consoleProducts.find(product => this.hasAvailableLooseConsoleVariant(product)) || consoleProducts[0] || null;
    }

    getSelectedBundleConsoleHandle() {
      const checked = this.querySelector('[data-bundle-console-select]:checked');
      if (checked && !checked.disabled) return checked.value;
      const defaultConsole = this.getDefaultBundleConsoleProduct();
      return defaultConsole ? defaultConsole.handle : '';
    }

    getSelectedBundleConsoleProduct() {
      const consoleProducts = this.getBundleConsoleProducts();
      const selectedHandle = this.getSelectedBundleConsoleHandle();
      return consoleProducts.find(product => product.handle === selectedHandle) || this.getDefaultBundleConsoleProduct();
    }

    selectDefaultBundleConsole() {
      const defaultConsole = this.getDefaultBundleConsoleProduct();
      if (!defaultConsole) return;

      const checked = this.querySelector('[data-bundle-console-select]:checked');
      if (checked && !checked.disabled && checked.value === defaultConsole.handle) return;

      const defaultInput = Array.from(this.querySelectorAll('[data-bundle-console-select]'))
        .find(input => input.value === defaultConsole.handle);
      if (defaultInput && !defaultInput.disabled) defaultInput.checked = true;
    }

    updateConsoleBundleConsoleOptions() {
      this.querySelectorAll('[data-bundle-console-option]').forEach((option) => {
        const input = option.querySelector('[data-bundle-console-select]');
        if (!input) return;

        const productConfig = this.getBundleConsoleProducts().find(product => product.handle === input.value);
        const unavailable = !this.hasAvailableLooseConsoleVariant(productConfig);
        input.disabled = unavailable;
        option.classList.toggle('is-unavailable', unavailable);
        option.querySelector('.rq-console-bundle__power-option-card')?.classList.toggle('is-unavailable', unavailable);
      });
    }

    initConsoleBundleImageZoom() {
      if (this.consoleBundleImageZoomBound) return;

      const modal = this.querySelector('[data-bundle-console-image-modal]');
      if (!modal) return;

      this.querySelectorAll('[data-bundle-console-zoom-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', () => this.openConsoleBundleImageModal());
      });

      this.querySelectorAll('[data-bundle-console-image-modal-close]').forEach((closeEl) => {
        closeEl.addEventListener('click', () => this.closeConsoleBundleImageModal());
      });

      this.querySelector('[data-bundle-console-image-modal-prev]')?.addEventListener('click', () => {
        this.changeConsoleBundleModalImage(-1);
      });
      this.querySelector('[data-bundle-console-image-modal-next]')?.addEventListener('click', () => {
        this.changeConsoleBundleModalImage(1);
      });

      document.addEventListener('keydown', (event) => {
        if (modal.hidden) return;
        if (event.key === 'Escape') {
          event.preventDefault();
          this.closeConsoleBundleImageModal();
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.changeConsoleBundleModalImage(-1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.changeConsoleBundleModalImage(1);
        }
      });

      this.consoleBundleImageZoomBound = true;
    }

    getConsoleBundleImageUrls(productConfig) {
      if (!productConfig) return [];

      const imageUrls = Array.isArray(productConfig.images)
        ? productConfig.images.filter(imageUrl => typeof imageUrl === 'string' && imageUrl)
        : [];
      if (!imageUrls.length && productConfig.image) imageUrls.push(productConfig.image);
      return imageUrls;
    }

    async fetchConsoleBundleImageUrls(productConfig) {
      const fallbackImages = this.getConsoleBundleImageUrls(productConfig);
      if (!productConfig?.handle) return fallbackImages;

      this.consoleBundleImageCache = this.consoleBundleImageCache || {};
      if (this.consoleBundleImageCache[productConfig.handle]) return this.consoleBundleImageCache[productConfig.handle];

      try {
        const response = await fetch(`/products/${productConfig.handle}.js`);
        if (!response.ok) throw new Error(`Unable to load product images for ${productConfig.handle}`);

        const productJson = await response.json();
        const fetchedImages = Array.isArray(productJson.images)
          ? productJson.images.filter(imageUrl => typeof imageUrl === 'string' && imageUrl)
          : [];
        const images = fetchedImages.length ? fetchedImages : fallbackImages;
        this.consoleBundleImageCache[productConfig.handle] = images;
        return images;
      } catch (error) {
        this.consoleBundleImageCache[productConfig.handle] = fallbackImages;
        return fallbackImages;
      }
    }

    setConsoleBundleModalImage(index) {
      const image = this.querySelector('[data-bundle-console-image-modal-img]');
      const prevButton = this.querySelector('[data-bundle-console-image-modal-prev]');
      const nextButton = this.querySelector('[data-bundle-console-image-modal-next]');
      const images = this.consoleBundleModalImages || [];
      if (!image || !images.length) return;

      this.consoleBundleModalImageIndex = ((index % images.length) + images.length) % images.length;
      image.src = images[this.consoleBundleModalImageIndex];
      image.alt = this.consoleBundleModalTitle || 'Console';

      const hasMultipleImages = images.length > 1;
      [prevButton, nextButton].forEach((button) => {
        if (!button) return;
        button.hidden = !hasMultipleImages;
        button.disabled = !hasMultipleImages;
      });
    }

    changeConsoleBundleModalImage(delta) {
      const images = this.consoleBundleModalImages || [];
      if (images.length <= 1) return;

      this.setConsoleBundleModalImage((this.consoleBundleModalImageIndex || 0) + delta);
    }

    async openConsoleBundleImageModal(productConfig = null) {
      const modal = this.querySelector('[data-bundle-console-image-modal]');
      const product = productConfig || this.getSelectedBundleConsoleProduct();
      const images = this.getConsoleBundleImageUrls(product);
      if (!modal || !product || !images.length) return;

      this.consoleBundleModalImages = images;
      this.consoleBundleModalTitle = product.title || 'Console';
      this.consoleBundleModalProductHandle = product.handle || '';
      this.setConsoleBundleModalImage(0);
      modal.hidden = false;
      document.body.classList.add('product-info-modal-open');
      requestAnimationFrame(() => {
        modal.classList.add('is-open');
        modal.querySelector('[data-bundle-console-image-modal-close]')?.focus();
      });

      const fetchedImages = await this.fetchConsoleBundleImageUrls(product);
      if (modal.hidden || product.handle !== this.consoleBundleModalProductHandle) return;
      this.consoleBundleModalImages = fetchedImages;
      this.setConsoleBundleModalImage(0);
    }

    closeConsoleBundleImageModal() {
      const modal = this.querySelector('[data-bundle-console-image-modal]');
      if (!modal) return;

      modal.classList.remove('is-open');
      document.body.classList.remove('product-info-modal-open');
      setTimeout(() => {
        if (!modal.classList.contains('is-open')) modal.hidden = true;
      }, 200);
    }

    getSelectedBundleAvHandle() {
      const checked = this.querySelector('[data-bundle-av-select]:checked');
      if (checked) return checked.value;
      const first = this.querySelector('[data-bundle-av-select]');
      return first ? first.value : '';
    }

    getSelectedBundlePowerSelectionValue() {
      const checked = this.querySelector('[data-bundle-power-select]:checked:not(:disabled)');
      if (checked) return checked.value;
      const first = this.querySelector('[data-bundle-power-select]:not(:disabled)');
      return first ? first.value : '';
    }

    powerProductMatchesSelectedVersion(productConfig) {
      const onlyShowForVersion = String(productConfig?.onlyShowForVersion || '').trim();
      if (!onlyShowForVersion) return true;

      const selectedVersion = String(this.getSelectedBundleConsoleAdvancedValue() || '').trim();
      return !!selectedVersion && onlyShowForVersion.toLowerCase() === selectedVersion.toLowerCase();
    }

    getVisibleBundlePowerProducts(powerProducts = null) {
      const products = Array.isArray(powerProducts)
        ? powerProducts
        : (Array.isArray(this.getConsoleBundleConfig()?.powerProducts) ? this.getConsoleBundleConfig().powerProducts : []);

      return products.filter(product => this.powerProductMatchesSelectedVersion(product));
    }

    syncConsoleBundlePowerOptions() {
      const configPowerProducts = Array.isArray(this.getConsoleBundleConfig()?.powerProducts)
        ? this.getConsoleBundleConfig().powerProducts
        : [];
      const visibleProducts = this.getVisibleBundlePowerProducts(configPowerProducts);
      const visibleHandles = new Set(visibleProducts.map(product => String(product.handle || '')));
      const visibleCount = visibleProducts.length;

      this.querySelectorAll('[data-bundle-power-option]').forEach((option) => {
        const input = option.querySelector('[data-bundle-power-select]');
        if (!input) return;

        const productConfig = configPowerProducts.find(product => String(product.handle || '') === String(input.value));
        const matchesVersion = productConfig ? visibleHandles.has(String(input.value)) : true;
        const available = productConfig ? this.hasAvailableBundleProductVariant(productConfig) : !input.classList.contains('disabled');
        const displayMode = option.dataset.bundlePowerDisplay || 'option';
        const hidden = !matchesVersion ||
          (displayMode === 'option' && visibleCount <= 1) ||
          (displayMode === 'extra' && visibleCount !== 1);

        option.classList.toggle('hidden', hidden);
        option.classList.toggle('rq-console-bundle__extra-item--disabled', !hidden && !available);
        input.disabled = hidden || !available;
        if (input.checked && input.disabled) input.checked = false;
      });

      const powerField = this.querySelector('[data-bundle-power-field]');
      if (powerField) {
        powerField.classList.toggle('hidden', visibleCount <= 1);
      }

      const extrasField = this.querySelector('[data-bundle-extras-field]');
      if (extrasField) {
        const hasVisibleExtra = !!extrasField.querySelector('.rq-console-bundle__extra-item:not(.hidden)');
        extrasField.classList.toggle('hidden', !hasVisibleExtra);
      }

      const checked = this.querySelector('[data-bundle-power-select]:checked:not(:disabled)');
      if (!checked) {
        const fallback = this.querySelector('[data-bundle-power-select]:not(:disabled)');
        if (fallback) fallback.checked = true;
      }
    }

    isBundlePlaceholderProduct(productConfig) {
      if (!productConfig) return true;
      const title = String(productConfig.title || '').trim().toUpperCase();
      const handle = String(productConfig.handle || '').trim().toLowerCase();
      return title === 'EMPTY PRODUCT' || handle === 'empty-product';
    }

    getBundleControllerOptions() {
      const controllerOptions = this.getConsoleBundleConfig()?.controllerOptions;
      return Array.isArray(controllerOptions)
        ? controllerOptions.filter((option) => option && this.isValidBundleProductConfig(option.controllerProduct))
        : [];
    }

    getBundleControllerProducts() {
      const controllerOptions = this.getBundleControllerOptions();
      if (controllerOptions.length) return controllerOptions.map((option) => option.controllerProduct).filter((product) => this.isValidBundleProductConfig(product));
      const controllerProducts = this.getConsoleBundleConfig()?.controllerProducts;
      if (Array.isArray(controllerProducts) && controllerProducts.length) return controllerProducts.filter((product) => this.isValidBundleProductConfig(product));
      const controller = this.getConsoleBundleConfig()?.controller;
      return this.isValidBundleProductConfig(controller) ? [controller] : [];
    }

    hasAvailableBundleProductVariant(productConfig) {
      return !!(productConfig && Array.isArray(productConfig.variants) && productConfig.variants.some((variant) => variant && variant.available));
    }

    getFirstAvailableBundleControllerProduct() {
      return this.getBundleControllerProducts().find((product) => this.hasAvailableBundleProductVariant(product)) || null;
    }

    updateConsoleBundleControllerProductOptions() {
      this.querySelectorAll('[data-bundle-controller-product-option]').forEach((option) => {
        const input = option.querySelector('[data-bundle-controller-product-select]');
        if (!input) return;

        const productConfig = this.getBundleControllerProducts().find((product) => product.handle === input.value);
        const unavailable = !this.hasAvailableBundleProductVariant(productConfig);
        input.disabled = unavailable;
        if (unavailable && input.checked) input.checked = false;
        option.classList.toggle('rq-console-bundle__extra-item--disabled', unavailable);
        option.classList.toggle('is-unavailable', unavailable);
        option.querySelector('.rq-console-bundle__power-option-card')?.classList.toggle('is-unavailable', unavailable);
      });
    }

    selectDefaultBundleControllerProduct() {
      const checked = this.querySelector('[data-bundle-controller-product-select]:checked');
      if (checked && !checked.disabled) return;

      const fallbackProduct = this.getFirstAvailableBundleControllerProduct();
      if (!fallbackProduct) return;

      const fallbackInput = Array.from(this.querySelectorAll('[data-bundle-controller-product-select]'))
        .find((input) => input.value === fallbackProduct.handle);
      if (fallbackInput && !fallbackInput.disabled) fallbackInput.checked = true;
    }

    getSelectedBundleControllerHandle() {
      const checked = this.querySelector('[data-bundle-controller-product-select]:checked');
      if (checked && !checked.disabled) return checked.value;
      const first = this.querySelector('[data-bundle-controller-product-select]:not(:disabled)');
      if (first) return first.value;
      const firstProduct = this.getFirstAvailableBundleControllerProduct() || this.getBundleControllerProducts()[0];
      return firstProduct ? firstProduct.handle : '';
    }

    getSelectedBundleControllerOption() {
      const controllerOptions = this.getBundleControllerOptions();
      if (!controllerOptions.length) return null;
      const selectedHandle = this.getSelectedBundleControllerHandle();
      return controllerOptions.find((option) => option.handle === selectedHandle) || controllerOptions[0] || null;
    }

    getSelectedBundleControllerProduct() {
      const selectedOption = this.getSelectedBundleControllerOption();
      if (selectedOption && selectedOption.controllerProduct) return selectedOption.controllerProduct;
      const controllerProducts = this.getBundleControllerProducts();
      if (!controllerProducts.length) return this.getConsoleBundleConfig()?.controller || null;
      const selectedHandle = this.getSelectedBundleControllerHandle();
      return controllerProducts.find((product) => product.handle === selectedHandle) || controllerProducts[0] || null;
    }

    getBundleControllerAddOns() {
      const addOns = this.getConsoleBundleConfig()?.controllerAddOns;
      return Array.isArray(addOns) ? addOns : [];
    }

    getBundleControllerAddOns2() {
      const addOns = this.getConsoleBundleConfig()?.controllerAddOns2;
      return Array.isArray(addOns) ? addOns : [];
    }

    getSelectedBundleControllerIndex() {
      const controllerProducts = this.getBundleControllerProducts();
      if (!controllerProducts.length) return 0;
      const selectedHandle = this.getSelectedBundleControllerHandle();
      const index = controllerProducts.findIndex((product) => product.handle === selectedHandle);
      return index === -1 ? 0 : index;
    }

    getSelectedBundleControllerAddOnProducts() {
      const selectedOption = this.getSelectedBundleControllerOption();
      if (selectedOption && Array.isArray(selectedOption.addOnProducts)) {
        return selectedOption.addOnProducts.filter((addOn) => !this.isBundlePlaceholderProduct(addOn));
      }
      const controllerIndex = this.getSelectedBundleControllerIndex();
      return [
        this.getBundleControllerAddOns()[controllerIndex] || null,
        this.getBundleControllerAddOns2()[controllerIndex] || null
      ].map((addOn) => (this.isBundlePlaceholderProduct(addOn) ? null : addOn));
    }

    getSelectedBundleControllerAddOnSelections() {
      const selectedCondition = this.getSelectedBundleCondition();
      return this.getSelectedBundleControllerAddOnProducts().map((productConfig, index) => {
        const checkbox = this.querySelector(`[data-bundle-controller-addon-select][data-addon-index="${index}"]`);
        let match = null;
        let variant = null;
        if (productConfig) {
          match = this.resolveBundleConditionedVariant(productConfig, selectedCondition);
          variant = match && match.variant ? match.variant : this.resolveBundleComponentVariant(productConfig);
        }
        return {
          index,
          product: productConfig,
          variant,
          matchedCondition: (match && match.matchedCondition) || this.getVariantConditionValue(productConfig, variant),
          exact: match ? match.exact : true,
          enabled: !!(checkbox && checkbox.checked && variant && variant.available)
        };
      }).filter((selection) => selection.product);
    }

    renderBundleControllerAddOns(selection) {
      const controllerAddOnsContainerEl = this.querySelector('[data-bundle-controller-addons-wrap]');
      if (!controllerAddOnsContainerEl) return [];

      const previousStates = new Map();
      controllerAddOnsContainerEl.querySelectorAll('[data-bundle-controller-addon-select]').forEach((checkbox) => {
        previousStates.set(checkbox.dataset.addonHandle || checkbox.value || checkbox.dataset.addonIndex || '', checkbox.checked);
      });

      const addOnProducts = this.getSelectedBundleControllerAddOnProducts();
      const controllerCount = selection ? selection.controllerCount : this.getSelectedBundleControllerCount();
      const selectedCondition = selection ? selection.selectedCondition : this.getSelectedBundleCondition();
      const availableAddOns = addOnProducts
        .map((product, index) => ({
          index,
          product,
          match: product ? this.resolveBundleConditionedVariant(product, selectedCondition) : null
        }))
        .map((entry) => ({
          ...entry,
          variant: entry.match && entry.match.variant ? entry.match.variant : (entry.product ? this.resolveBundleComponentVariant(entry.product) : null)
        }))
        .filter((entry) => entry.product && entry.variant && entry.variant.available);

      if (!availableAddOns.length) {
        controllerAddOnsContainerEl.innerHTML = '';
        controllerAddOnsContainerEl.classList.add('hidden');
        return [];
      }

      controllerAddOnsContainerEl.innerHTML = availableAddOns.map((entry) => {
        const handle = this.escapeHtml(entry.product.handle || `addon-${entry.index}`);
        const parsedTitle = this.parseBundleDisplayTitle(entry.product.title);
        const addOnBaseTitle = parsedTitle.baseTitle || entry.product.title;
        const label = `Add ${controllerCount} ${addOnBaseTitle}${controllerCount === 1 ? '' : 's'}`;
        const priceToAdd = (entry.variant.price || 0) * controllerCount * ((selection && selection.quantity) || this.getSelectedQuantity() || 1);
        const formattedPrice = Shopify.formatMoney(priceToAdd, window.money_format);
        const checked = previousStates.get(entry.product.handle || String(entry.index)) ? 'checked' : '';
        const matchedCondition = (entry.match && entry.match.matchedCondition) || this.getVariantConditionValue(entry.product, entry.variant);
        const conditionLabel = matchedCondition ? this.formatBundleConditionLabel(matchedCondition) : '';
        const subMetaParts = [];
        const manufacturerBadge = this.renderBundleManufacturerBadge(entry.product, ' rq-console-bundle__manufacturer-badge--row');
        if (manufacturerBadge) subMetaParts.push(manufacturerBadge);
        if (conditionLabel) subMetaParts.push(`<span class="rq-console-bundle__title-meta-line">${conditionLabel}</span>`);
        if (parsedTitle.styleLabel) subMetaParts.push(`<span class="rq-console-bundle__title-meta-line">${this.escapeHtml(parsedTitle.styleLabel)}</span>`);
        const imageMarkup = entry.product.image
          ? `<img class="rq-console-bundle__controller-addon-thumb" src="${this.escapeHtml(entry.product.image)}" alt="" loading="lazy" width="40" height="40">`
          : '';
        return `
          <label class="rq-console-bundle__power-option rq-optional-extras__option rq-console-bundle__controller-addon" data-bundle-controller-addon-wrap data-addon-index="${entry.index}">
            <input
              type="checkbox"
              class="rq-console-bundle__controller-addon-checkbox"
              data-bundle-controller-addon-select
              data-addon-index="${entry.index}"
              data-addon-handle="${handle}"
              ${checked}
            >
            <span class="rq-console-bundle__power-option-card rq-optional-extras__card rq-console-bundle__controller-addon-card">
              <span class="rq-console-bundle__optional-addon-checkbox rq-optional-extras__checkbox" aria-hidden="true"></span>
              ${imageMarkup}
              <span class="rq-addon-cleaning__text rq-console-bundle__controller-addon-text">
                <span class="rq-addon-cleaning__title">
                  <span class="rq-addon-cleaning__title-text" data-bundle-controller-addon-label data-addon-index="${entry.index}">${this.escapeHtml(label)}</span>
                </span>
                ${subMetaParts.length ? `<span class="rq-console-bundle__controller-addon-desc">${subMetaParts.join('')}</span>` : ''}
              </span>
              <span class="rq-addon-cleaning__price rq-console-bundle__controller-addon-price">${this.escapeHtml(formattedPrice)}</span>
            </span>
          </label>
        `;
      }).join('');
      controllerAddOnsContainerEl.classList.remove('hidden');

      return this.getSelectedBundleControllerAddOnSelections();
    }

    getBundleMemoryCardProducts() {
      const products = this.getConsoleBundleConfig()?.memoryCardProducts;
      return Array.isArray(products) ? products.filter((product) => !this.isBundlePlaceholderProduct(product)) : [];
    }

    getSelectedBundleMemoryCardHandle() {
      const checked = this.querySelector('[data-bundle-memory-card-select]:checked');
      if (checked) return checked.value;
      const first = this.querySelector('[data-bundle-memory-card-select]');
      if (first) return first.value;
      const firstProduct = this.getBundleMemoryCardProducts()[0];
      return firstProduct ? firstProduct.handle : '';
    }

    getSelectedBundleMemoryCardProduct() {
      const memoryCardProducts = this.getBundleMemoryCardProducts();
      if (!memoryCardProducts.length) return null;
      const selectedHandle = this.getSelectedBundleMemoryCardHandle();
      return memoryCardProducts.find((product) => product.handle === selectedHandle) || memoryCardProducts[0] || null;
    }

    getSelectedBundleMemoryCardQuantity() {
      const checked = this.querySelector('[data-bundle-memory-card-qty-input]:checked');
      if (checked) return Math.max(parseInt(checked.value || '0', 10) || 0, 0);

      return this.getSelectedBundleMemoryCardItems().reduce((total, item) => total + item.quantity, 0);
    }

    getSelectedBundleMemoryCardMaxSelectableQuantity() {
      const memoryCardProduct = this.getSelectedBundleMemoryCardProduct();
      const memoryCardVariant = memoryCardProduct ? this.resolveBundleComponentVariant(memoryCardProduct) : null;
      if (!memoryCardVariant || !memoryCardVariant.available) return 0;
      if (memoryCardVariant.inventoryManagement !== 'shopify' || memoryCardVariant.inventoryPolicy === 'continue') return 4;
      return Math.max(Math.min(parseInt(memoryCardVariant.inventoryQuantity || 0, 10) || 0, 4), 0);
    }

    getBundleMemoryCardMaxSelectableQuantityForProduct(memoryCardProduct) {
      const memoryCardVariant = memoryCardProduct ? this.resolveBundleComponentVariant(memoryCardProduct) : null;
      if (!memoryCardVariant || !memoryCardVariant.available) return 0;
      if (memoryCardVariant.inventoryManagement !== 'shopify' || memoryCardVariant.inventoryPolicy === 'continue') return 4;
      return Math.max(Math.min(parseInt(memoryCardVariant.inventoryQuantity || 0, 10) || 0, 4), 0);
    }

    clampBundleMemoryCardQuantity(input) {
      if (!input) return 0;

      const card = input.closest('[data-bundle-memory-card-option]');
      const select = card ? card.querySelector('[data-bundle-memory-card-select]') : null;
      const product = select ? this.getBundleMemoryCardProducts().find((memoryCardProduct) => memoryCardProduct.handle === select.value) : this.getSelectedBundleMemoryCardProduct();
      const maxFromProduct = this.getBundleMemoryCardMaxSelectableQuantityForProduct(product);
      const maxRaw = parseInt(input.max || '', 10);
      const maxFromInput = input.hasAttribute('max') && Number.isFinite(maxRaw) ? maxRaw : 4;
      const max = Math.max(Math.min(maxFromProduct, maxFromInput), 0);
      let value = parseInt(input.value || '0', 10);
      if (!Number.isFinite(value)) value = 0;
      value = Math.max(Math.min(value, max), 0);

      input.value = String(value);
      input.disabled = max <= 0;
      if (select) {
        select.disabled = max <= 0;
        select.checked = max > 0 && value > 0;
      }
      if (card) card.classList.toggle('rq-console-bundle__extra-item--disabled', max <= 0);
      this.updateBundleMemoryCardPrice(input, value, max <= 0);

      const stepper = input.closest('[data-bundle-memory-card-qty-stepper]');
      if (stepper) {
        const decrement = stepper.querySelector('[data-bundle-memory-card-qty-decrement]');
        const increment = stepper.querySelector('[data-bundle-memory-card-qty-increment]');
        if (decrement) decrement.disabled = value <= 0 || max <= 0;
        if (increment) increment.disabled = value >= max || max <= 0;
      }

      return value;
    }

    getSelectedBundleMemoryCardItems() {
      return Array.from(this.querySelectorAll('[data-bundle-memory-card-select]:checked')).map((input) => {
        if (!input || input.disabled) return null;

        const product = this.getBundleMemoryCardProducts().find((memoryCardProduct) => memoryCardProduct.handle === input.value);
        const variant = product ? this.resolveBundleComponentVariant(product) : null;
        if (!variant || !variant.available) return null;

        const card = input.closest('[data-bundle-memory-card-option]');
        const qtyInput = card ? card.querySelector('[data-bundle-memory-card-qty-input]') : null;
        const quantity = qtyInput ? this.clampBundleMemoryCardQuantity(qtyInput) : 0;
        if (quantity <= 0) return null;

        return {
          product,
          variant,
          quantity
        };
      }).filter(Boolean);
    }

    updateBundleMemoryCardPrice(input, quantity = null, unavailable = false) {
      const card = input ? input.closest('[data-bundle-memory-card-option]') : null;
      const priceEl = card ? card.querySelector('[data-bundle-memory-card-price]') : null;
      if (!priceEl) return;
      if (unavailable || !input || input.disabled) {
        priceEl.textContent = 'Out of stock';
        return;
      }

      const unitPrice = Math.max(parseInt(priceEl.dataset.bundleMemoryCardUnitPrice || '0', 10) || 0, 0);
      const displayQuantity = Math.max(quantity === null ? parseInt(input.value || '0', 10) || 0 : quantity, 1);
      priceEl.textContent = `+ ${Shopify.formatMoney(unitPrice * displayQuantity, window.money_format)}`;
    }

    stepBundleMemoryCardQuantity(button) {
      const stepper = button.closest('[data-bundle-memory-card-qty-stepper]');
      const input = stepper ? stepper.querySelector('[data-bundle-memory-card-qty-input]') : null;
      if (!input) return;

      const current = this.clampBundleMemoryCardQuantity(input);
      const direction = button.matches('[data-bundle-memory-card-qty-increment]') ? 1 : -1;
      input.value = String(current + direction);
      this.clampBundleMemoryCardQuantity(input);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    getBundleBatteryProducts() {
      const products = this.getConsoleBundleConfig()?.batteryProducts;
      return Array.isArray(products) ? products.filter((product) => !this.isBundlePlaceholderProduct(product)) : [];
    }

    getSelectedBundleBatteryHandle() {
      const checked = this.querySelector('[data-bundle-battery-select]:checked');
      if (checked) return checked.value;
      const first = this.querySelector('[data-bundle-battery-select]');
      if (first) return first.value;
      const firstProduct = this.getBundleBatteryProducts()[0];
      return firstProduct ? firstProduct.handle : '';
    }

    getSelectedBundleBatteryProduct() {
      const batteryProducts = this.getBundleBatteryProducts();
      if (!batteryProducts.length) return null;
      const selectedHandle = this.getSelectedBundleBatteryHandle();
      return batteryProducts.find((product) => product.handle === selectedHandle) || batteryProducts[0] || null;
    }

    getSelectedBundleBatteryQuantity() {
      const checked = this.querySelector('[data-bundle-battery-qty-input]:checked');
      if (checked) return Math.max(parseInt(checked.value || '0', 10) || 0, 0);

      return this.getSelectedBundleBatteryItems().reduce((total, item) => total + item.quantity, 0);
    }

    getSelectedBundleBatteryMaxSelectableQuantity() {
      const batteryProduct = this.getSelectedBundleBatteryProduct();
      return this.getBundleBatteryMaxSelectableQuantityForProduct(batteryProduct);
    }

    getBundleBatteryMaxSelectableQuantityForProduct(batteryProduct) {
      const batteryVariant = batteryProduct ? this.resolveBundleComponentVariant(batteryProduct) : null;
      if (!batteryVariant || !batteryVariant.available) return 0;
      if (batteryVariant.inventoryManagement !== 'shopify' || batteryVariant.inventoryPolicy === 'continue') return 4;
      return Math.max(Math.min(parseInt(batteryVariant.inventoryQuantity || 0, 10) || 0, 4), 0);
    }

    getSelectedBundleBatteryItems() {
      return Array.from(this.querySelectorAll('[data-bundle-battery-select]:checked')).map((input) => {
        if (!input || input.disabled) return null;

        const product = this.getBundleBatteryProducts().find((batteryProduct) => batteryProduct.handle === input.value);
        const variant = product ? this.resolveBundleComponentVariant(product) : null;
        if (!variant || !variant.available) return null;

        const card = input.closest('[data-bundle-battery-option]');
        const qtyInput = card ? card.querySelector('[data-bundle-battery-qty-input]') : null;
        const quantity = qtyInput ? this.clampBundleBatteryQuantity(qtyInput) : 0;
        if (quantity <= 0) return null;

        return {
          product,
          variant,
          quantity
        };
      }).filter(Boolean);
    }

    clampBundleBatteryQuantity(input) {
      if (!input) return 0;

      const card = input.closest('[data-bundle-battery-option]');
      const select = card ? card.querySelector('[data-bundle-battery-select]') : null;
      const product = select ? this.getBundleBatteryProducts().find((batteryProduct) => batteryProduct.handle === select.value) : this.getSelectedBundleBatteryProduct();
      const maxFromProduct = this.getBundleBatteryMaxSelectableQuantityForProduct(product);
      const maxRaw = parseInt(input.max || '', 10);
      const maxFromInput = input.hasAttribute('max') && Number.isFinite(maxRaw) ? maxRaw : 4;
      const max = Math.max(Math.min(maxFromProduct, maxFromInput), 0);
      let value = parseInt(input.value || '0', 10);
      if (!Number.isFinite(value)) value = 0;
      value = Math.max(Math.min(value, max), 0);

      input.value = String(value);
      input.disabled = max <= 0;
      if (select) select.checked = value > 0;
      this.updateBundleBatteryCardPrice(input, value);

      const stepper = input.closest('[data-bundle-battery-qty-stepper]');
      if (stepper) {
        const decrement = stepper.querySelector('[data-bundle-battery-qty-decrement]');
        const increment = stepper.querySelector('[data-bundle-battery-qty-increment]');
        if (decrement) decrement.disabled = value <= 0 || max <= 0;
        if (increment) increment.disabled = value >= max || max <= 0;
      }

      return value;
    }

    updateBundleBatteryCardPrice(input, quantity = null) {
      const card = input ? input.closest('[data-bundle-battery-option]') : null;
      const priceEl = card ? card.querySelector('[data-bundle-battery-price]') : null;
      if (!priceEl) return;

      const unitPrice = Math.max(parseInt(priceEl.dataset.bundleBatteryUnitPrice || '0', 10) || 0, 0);
      const displayQuantity = Math.max(quantity === null ? parseInt(input.value || '0', 10) || 0 : quantity, 1);
      priceEl.textContent = `+ ${Shopify.formatMoney(unitPrice * displayQuantity, window.money_format)}`;
    }

    stepBundleBatteryQuantity(button) {
      const stepper = button.closest('[data-bundle-battery-qty-stepper]');
      const input = stepper ? stepper.querySelector('[data-bundle-battery-qty-input]') : null;
      if (!input) return;

      const current = this.clampBundleBatteryQuantity(input);
      const direction = button.matches('[data-bundle-battery-qty-increment]') ? 1 : -1;
      input.value = String(current + direction);
      this.clampBundleBatteryQuantity(input);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    updateConsoleBundleAvOptionPricing() {
      const selectedInput = this.querySelector('[data-bundle-av-select]:checked') || this.querySelector('[data-bundle-av-select]');
      if (!selectedInput) return;

      const selectedOption = selectedInput.closest('[data-bundle-av-option]');
      const selectedPriceEl = selectedOption ? selectedOption.querySelector('[data-bundle-av-option-price]') : null;
      const selectedBasePrice = selectedPriceEl ? parseInt(selectedPriceEl.dataset.bundleAvOptionBasePrice || '0', 10) || 0 : 0;

      this.querySelectorAll('[data-bundle-av-option]').forEach((option) => {
        const input = option.querySelector('[data-bundle-av-select]');
        const priceEl = option.querySelector('[data-bundle-av-option-price]');
        if (!input || !priceEl) return;

        const basePrice = parseInt(priceEl.dataset.bundleAvOptionBasePrice || '0', 10) || 0;
        const delta = basePrice - selectedBasePrice;

        if (input.checked || delta === 0) {
          priceEl.textContent = '';
          priceEl.classList.add('hidden');
          return;
        }

        const absoluteDeltaLabel = Shopify.formatMoney(Math.abs(delta), window.money_format);
        priceEl.textContent = `${delta > 0 ? '+' : '-'}${absoluteDeltaLabel}`;
        priceEl.classList.remove('hidden');
      });
    }

    updateConsoleBundleConsoleOptionPricing() {
      const selectedInput = this.querySelector('[data-bundle-console-select]:checked') || this.querySelector('[data-bundle-console-select]');
      if (!selectedInput) return;

      const consoleProducts = this.getBundleConsoleProducts();
      const selectedProduct = consoleProducts.find(product => product.handle === selectedInput.value) || this.getSelectedBundleConsoleProduct();
      const selectedCondition = this.getSelectedBundleCondition();
      const selectedBasePrice = this.getLooseConsolePriceForCondition(selectedProduct, selectedCondition);

      this.querySelectorAll('[data-bundle-console-option]').forEach((option) => {
        const input = option.querySelector('[data-bundle-console-select]');
        const priceEl = option.querySelector('[data-bundle-console-option-price]');
        if (!input || !priceEl) return;
        if (!selectedBasePrice) {
          priceEl.textContent = '';
          priceEl.classList.add('hidden');
          return;
        }

        const product = consoleProducts.find(consoleProduct => consoleProduct.handle === input.value);
        const basePrice = this.getLooseConsolePriceForCondition(product, selectedCondition);
        const delta = basePrice - selectedBasePrice;

        if (!basePrice || input.checked || delta === 0) {
          priceEl.textContent = '';
          priceEl.classList.add('hidden');
          return;
        }

        const absoluteDeltaLabel = Shopify.formatMoney(Math.abs(delta), window.money_format);
        priceEl.textContent = `${delta > 0 ? '+' : '-'}${absoluteDeltaLabel}`;
        priceEl.classList.remove('hidden');
      });
    }

    updateConsoleBundlePowerOptionPricing() {
      this.syncConsoleBundlePowerOptions();
      const selectedInput = this.querySelector('[data-bundle-power-select]:checked') || this.querySelector('[data-bundle-power-select]');
      if (!selectedInput) return;

      const selectedOption = selectedInput.closest('[data-bundle-power-option]');
      const selectedPriceEl = selectedOption ? selectedOption.querySelector('[data-bundle-power-option-price]') : null;
      const selectedBasePrice = selectedPriceEl ? parseInt(selectedPriceEl.dataset.bundlePowerOptionBasePrice || '0', 10) || 0 : 0;

      this.querySelectorAll('[data-bundle-power-option]').forEach((option) => {
        if (option.classList.contains('hidden')) return;
        const input = option.querySelector('[data-bundle-power-select]');
        const priceEl = option.querySelector('[data-bundle-power-option-price]');
        if (!input || !priceEl) return;

        const basePrice = parseInt(priceEl.dataset.bundlePowerOptionBasePrice || '0', 10) || 0;
        const delta = basePrice - selectedBasePrice;

        if (input.checked || delta === 0) {
          priceEl.textContent = '';
          priceEl.classList.add('hidden');
          return;
        }

        const absoluteDeltaLabel = Shopify.formatMoney(Math.abs(delta), window.money_format);
        priceEl.textContent = `${delta > 0 ? '+' : '-'}${absoluteDeltaLabel}`;
        priceEl.classList.remove('hidden');
      });
    }

    getSelectedBundleControllerCount() {
      const checked = this.querySelector('[data-bundle-controller-count-select]:checked');
      const count = parseInt(checked && checked.value ? checked.value : '1', 10) || 1;
      return Math.max(Math.min(count, 4), 1);
    }

    getBundleGameConfigs() {
      const games = this.getConsoleBundleConfig()?.games;
      return Array.isArray(games) ? games : [];
    }

    getBundleConsoleAddOnConfig() {
      const consoleAddOn = this.getConsoleBundleConfig()?.consoleAddOn;
      return consoleAddOn && typeof consoleAddOn === 'object' ? consoleAddOn : null;
    }

    getBundleOtherExtras() {
      const extras = this.getConsoleBundleConfig()?.otherExtras;
      return Array.isArray(extras) ? extras : [];
    }

    getBundleOptionalAddOns() {
      const addOns = this.getConsoleBundleConfig()?.optionalAddOns;
      return Array.isArray(addOns) ? addOns : [];
    }

    getSelectedBundleOptionalAddOns() {
      return this.getBundleOptionalAddOns().map((addOnConfig, addOnIndex) => {
        const input = this.querySelector(`[data-bundle-optional-addon-select][data-addon-index="${addOnIndex}"]`);
        return {
          addOnIndex,
          title: addOnConfig.title,
          enabled: !!(input && input.checked),
          variant: this.resolveBundleComponentVariant(addOnConfig)
        };
      });
    }

    getConsoleAddOnTypeEntries() {
      const consoleAddOnConfig = this.getBundleConsoleAddOnConfig();
      if (!consoleAddOnConfig || !Array.isArray(consoleAddOnConfig.variants) || !consoleAddOnConfig.variants.length) return [];

      const typeIndex = this.getProductOptionIndex(consoleAddOnConfig, /item type|type|completeness/i);
      if (typeIndex === -1) return [];

      const byLabel = new Map();
      consoleAddOnConfig.variants.forEach((variant) => {
        if (!variant || !Array.isArray(variant.options)) return;
        const label = variant.options[typeIndex];
        if (!label) return;
        const existing = byLabel.get(label) || { label, available: false };
        if (variant.available) existing.available = true;
        byLabel.set(label, existing);
      });

      return Array.from(byLabel.values());
    }

    renderConsoleBundleConsoleAddOnTypeOptions() {
      const consoleAddOnConfig = this.getBundleConsoleAddOnConfig();
      const field = this.querySelector('[data-bundle-console-addon-type-field]');
      const container = this.querySelector('[data-bundle-console-addon-type-options]');
      if (!field || !container) return;

      if (!consoleAddOnConfig) {
        field.classList.add('hidden');
        container.innerHTML = '';
        return;
      }

      const entries = this.getConsoleAddOnTypeEntries();
      if (!entries.length) {
        field.classList.add('hidden');
        container.innerHTML = '';
        return;
      }

      field.classList.remove('hidden');
      const defaultIndex = Math.max(entries.findIndex((entry) => entry.available), 0);

      container.innerHTML = entries.map((entry, index) => {
        const id = `${this.dataset.section || 'bundle'}-${this.dataset.id || 'product'}-bundle-console-addon-type-${index}`;
        return `
          <div class="variant-options-wrap">
            <input
              type="radio"
              id="${id}"
              name="bundle-console-addon-type-${this.dataset.id || 'product'}"
              value="${entry.label}"
              ${index === defaultIndex && entry.available ? 'checked' : ''}
              ${entry.available ? '' : 'class="disabled"'}
            >
            <label data-option-name="${entry.label}" class="variant-element_label" for="${id}">
              <span class="variant-element_span">${entry.label}</span>
              <span style="color: #000; background-color: #fff;" class="label-text-sibling ${entry.available ? 'hidden' : 'visually-hidden'}">
                ${window.variantStrings && window.variantStrings.unavailable ? window.variantStrings.unavailable : 'Sold out or unavailable'}
              </span>
            </label>
          </div>
        `;
      }).join('');

      container.querySelectorAll('input[type="radio"]').forEach((input) => {
        if (!input.dataset.bundleBound) {
          input.addEventListener('change', () => this.updateConsoleBundle());
          input.dataset.bundleBound = 'true';
        }
      });
    }

    getSelectedBundleConsoleAddOnType() {
      const checked = this.querySelector('[data-bundle-console-addon-type-options] input[type="radio"]:checked');
      return checked ? checked.value : null;
    }

    getBundleGameRow(gameIndex) {
      return this.querySelector(`[data-bundle-game-row][data-game-index="${gameIndex}"]`);
    }

    getGameItemTypeEntries(gameIndex) {
      const gameConfig = this.getBundleGameConfigs()[gameIndex];
      if (!gameConfig || !Array.isArray(gameConfig.variants) || !gameConfig.variants.length) return [];

      const typeIndex = this.getProductOptionIndex(gameConfig, /item type|type|completeness/i);
      if (typeIndex === -1) return [];

      const byLabel = new Map();
      gameConfig.variants.forEach((variant) => {
        if (!variant || !Array.isArray(variant.options)) return;
        const label = variant.options[typeIndex];
        if (!label) return;
        const existing = byLabel.get(label) || { label, available: false };
        if (variant.available) existing.available = true;
        byLabel.set(label, existing);
      });

      return Array.from(byLabel.values());
    }

    renderConsoleBundleGameTypeOptions(gameIndex) {
      const row = this.getBundleGameRow(gameIndex);
      const field = row ? row.querySelector('[data-bundle-game-type-field]') : null;
      const container = row ? row.querySelector('[data-bundle-game-type-options]') : null;
      if (!field || !container) return;

      const entries = this.getGameItemTypeEntries(gameIndex);
      if (!entries.length) {
        field.classList.add('hidden');
        return;
      }

      field.classList.remove('hidden');
      const defaultIndex = Math.max(entries.findIndex((entry) => entry.available), 0);

      container.innerHTML = entries.map((entry, index) => {
        const id = `${this.dataset.section || 'bundle'}-${this.dataset.id || 'product'}-bundle-game-type-${gameIndex}-${index}`;
        return `
          <div class="variant-options-wrap">
            <input
              type="radio"
              id="${id}"
              name="bundle-game-type-${this.dataset.id || 'product'}-${gameIndex}"
              value="${entry.label}"
              ${index === defaultIndex && entry.available ? 'checked' : ''}
              ${entry.available ? '' : 'class="disabled"'}
            >
            <label data-option-name="${entry.label}" class="variant-element_label" for="${id}">
              <span class="variant-element_span">${entry.label}</span>
              <span style="color: #000; background-color: #fff;" class="label-text-sibling ${entry.available ? 'hidden' : 'visually-hidden'}">
                ${window.variantStrings && window.variantStrings.unavailable ? window.variantStrings.unavailable : 'Sold out or unavailable'}
              </span>
            </label>
          </div>
        `;
      }).join('');

      container.querySelectorAll('input[type="radio"]').forEach((input) => {
        if (!input.dataset.bundleBound) {
          input.addEventListener('change', () => {
            this.renderConsoleBundleGameCoverTypeOptions(gameIndex);
            this.updateConsoleBundle();
          });
          input.dataset.bundleBound = 'true';
        }
      });
    }

    getSelectedBundleGameType(gameIndex) {
      const row = this.getBundleGameRow(gameIndex);
      const checked = row ? row.querySelector('[data-bundle-game-type-options] input[type="radio"]:checked') : null;
      return checked ? checked.value : null;
    }

    getGameCoverTypeEntries(gameIndex) {
      const gameConfig = this.getBundleGameConfigs()[gameIndex];
      if (!gameConfig || !Array.isArray(gameConfig.variants) || !gameConfig.variants.length) return [];

      const selectedGameType = this.getSelectedBundleGameType(gameIndex);
      const typeIndex = this.getProductOptionIndex(gameConfig, /item type|type|completeness/i);
      const coverTypeIndex = this.getProductOptionIndex(gameConfig, /cover type/i);
      if (coverTypeIndex === -1) return [];

      const byLabel = new Map();
      gameConfig.variants.forEach((variant) => {
        if (!variant || !Array.isArray(variant.options)) return;
        if (selectedGameType && typeIndex !== -1 && String(variant.options[typeIndex] || '') !== String(selectedGameType)) return;

        const label = variant.options[coverTypeIndex];
        if (!label) return;

        const existing = byLabel.get(label) || { label, available: false };
        if (variant.available) existing.available = true;
        byLabel.set(label, existing);
      });

      return Array.from(byLabel.values());
    }

    renderConsoleBundleGameCoverTypeOptions(gameIndex) {
      const row = this.getBundleGameRow(gameIndex);
      const field = row ? row.querySelector('[data-bundle-game-cover-type-field]') : null;
      const container = row ? row.querySelector('[data-bundle-game-cover-type-options]') : null;
      if (!field || !container) return;

      const entries = this.getGameCoverTypeEntries(gameIndex);
      if (entries.length <= 1) {
        field.classList.add('hidden');
        container.innerHTML = '';
        return;
      }

      field.classList.remove('hidden');
      const existingValue = this.getSelectedBundleGameCoverType(gameIndex);
      const defaultIndex = existingValue
        ? Math.max(entries.findIndex((entry) => entry.label === existingValue && entry.available), 0)
        : Math.max(entries.findIndex((entry) => entry.available), 0);

      container.innerHTML = entries.map((entry, index) => {
        const id = `${this.dataset.section || 'bundle'}-${this.dataset.id || 'product'}-bundle-game-cover-type-${gameIndex}-${index}`;
        return `
          <div class="variant-options-wrap">
            <input
              type="radio"
              id="${id}"
              name="bundle-game-cover-type-${this.dataset.id || 'product'}-${gameIndex}"
              value="${entry.label}"
              ${index === defaultIndex && entry.available ? 'checked' : ''}
              ${entry.available ? '' : 'class="disabled"'}
            >
            <label data-option-name="${entry.label}" class="variant-element_label" for="${id}">
              <span class="variant-element_span">${entry.label}</span>
              <span style="color: #000; background-color: #fff;" class="label-text-sibling ${entry.available ? 'hidden' : 'visually-hidden'}">
                ${window.variantStrings && window.variantStrings.unavailable ? window.variantStrings.unavailable : 'Sold out or unavailable'}
              </span>
            </label>
          </div>
        `;
      }).join('');

      container.querySelectorAll('input[type="radio"]').forEach((input) => {
        if (!input.dataset.bundleBound) {
          input.addEventListener('change', () => this.updateConsoleBundle());
          input.dataset.bundleBound = 'true';
        }
      });
    }

    getSelectedBundleGameCoverType(gameIndex) {
      const row = this.getBundleGameRow(gameIndex);
      const checked = row ? row.querySelector('[data-bundle-game-cover-type-options] input[type="radio"]:checked') : null;
      return checked ? checked.value : null;
    }

    getBundleControllerTotalAvailable() {
      const controllerConfig = this.getSelectedBundleControllerProduct();
      if (!controllerConfig || !Array.isArray(controllerConfig.variants) || !controllerConfig.variants.length) return 0;

      return controllerConfig.variants
        .filter(variant => variant && variant.available)
        .reduce((sum, variant) => {
          const availableQuantity = this.getVariantAvailableQuantity(variant);
          if (availableQuantity === Number.MAX_SAFE_INTEGER) return Number.MAX_SAFE_INTEGER;
          return sum + availableQuantity;
        }, 0);
    }

    getControllerSlotAllocation(slotCount) {
      const selectedCondition = this.getSelectedBundleCondition();
      const controllerConfig = this.getSelectedBundleControllerProduct();
      if (!controllerConfig || slotCount < 1) return null;

      const allocationResult = this.resolveBundleConditionedAllocations(controllerConfig, selectedCondition, slotCount);
      if (!allocationResult.complete || !allocationResult.allocations.length) return null;

      let remainingSlots = slotCount;
      for (const allocation of allocationResult.allocations) {
        if (remainingSlots <= allocation.quantity) return allocation;
        remainingSlots -= allocation.quantity;
      }

      return null;
    }

    getControllerAllocationResult(count) {
      const selectedCondition = this.getSelectedBundleCondition();
      const controllerConfig = this.getSelectedBundleControllerProduct();
      if (!controllerConfig || count < 1) {
        return { allocations: [], complete: false, remaining: count };
      }

      return this.resolveBundleConditionedAllocations(controllerConfig, selectedCondition, count);
    }

    getControllerAllocationTotal(allocations) {
      if (!Array.isArray(allocations)) return 0;

      return allocations.reduce((total, allocation) => {
        const price = allocation && allocation.variant ? (allocation.variant.price || 0) : 0;
        const quantity = allocation ? (allocation.quantity || 0) : 0;
        return total + (price * quantity);
      }, 0);
    }

    formatControllerComposition(allocations) {
      if (!Array.isArray(allocations) || !allocations.length) return '';

      return allocations
        .map((allocation) => {
          const quantity = allocation.quantity || 0;
          const conditionLabel = allocation.matchedCondition
            ? String(allocation.matchedCondition).trim()
            : 'Available';
          return `${quantity} x ${conditionLabel}`;
        })
        .join(', ');
    }

    ensureControllerCompositionHelp(compositionEl) {
      if (!compositionEl) return;

      const existingWrap = compositionEl.parentElement && compositionEl.parentElement.matches('[data-bundle-controller-composition-wrap]')
        ? compositionEl.parentElement
        : null;
      const targetWrap = existingWrap || compositionEl;
      if (targetWrap.querySelector('[data-bundle-controller-composition-help]')) return;

      const helpText = 'We try to match controller grades to your console selection as closely as possible. If there is not enough stock in that grade, nearby grades are substituted where needed.';
      const modalId = `bundle-controller-composition-whats-this-${this.dataset.section || 'main'}`;
      const helpWrap = document.createElement('span');
      helpWrap.className = 'variant-tooltip-wrap rq-console-bundle__controller-composition-help-wrap';
      helpWrap.dataset.modalTarget = modalId;
      helpWrap.dataset.bundleControllerCompositionHelp = 'true';
      helpWrap.innerHTML = `
        <button
          type="button"
          class="variant-tooltip-trigger rq-console-bundle__controller-composition-help"
          aria-label="${this.escapeHtml(helpText)}"
          aria-haspopup="dialog"
          aria-expanded="false"
          aria-controls="${this.escapeHtml(modalId)}"
          data-product-info-tooltip-trigger
          data-bundle-controller-composition-help
          data-tooltip-force-modal="true"
        >
          <span class="tooltip-trigger-text">What's this?</span>
        </button>
        <span class="variant-tooltip variant-tooltip--wide rq-console-bundle__controller-composition-tooltip" role="tooltip">
          <p class="cleaning-tooltip_intro">${this.escapeHtml(helpText)}</p>
        </span>
      `;

      if (!existingWrap) compositionEl.classList.add('rq-console-bundle__controller-composition--with-help');
      targetWrap.appendChild(helpWrap);

      if (!document.getElementById(modalId)) {
        const modal = document.createElement('div');
        modal.className = 'product-info-modal product-info-modal--bundle-whats-this product-info-modal--controller-composition';
        modal.id = modalId;
        modal.setAttribute('role', 'dialog');
        modal.setAttribute('aria-modal', 'true');
        modal.setAttribute('aria-labelledby', `${modalId}-title`);
        modal.hidden = true;
        modal.innerHTML = `
          <div class="product-info-modal_backdrop"></div>
          <div class="product-info-modal_panel">
            <div class="product-info-modal_header">
              <strong class="product-info-modal_title" id="${this.escapeHtml(modalId)}-title">Controller grades</strong>
            </div>
            <p class="cleaning-modal_intro">${this.escapeHtml(helpText)}</p>
          </div>
        `;
        document.body.appendChild(modal);
      }

      if (window.initProductInfoTooltips) window.initProductInfoTooltips(document);
    }

    normalizeControllerCompositionPlacement() {
      const compositionWrap = this.querySelector('[data-bundle-controller-composition-wrap]');
      const optionsContainer = this.querySelector('[data-bundle-controller-options]');
      if (!compositionWrap || !optionsContainer) return;

      const hasMultipleControllerTypes = !!this.querySelector('[data-bundle-controller-product-options]');
      let amountHeading = this.querySelector('.rq-console-bundle__controller-amount-heading');
      if (!hasMultipleControllerTypes) {
        if (amountHeading) amountHeading.remove();
        if (compositionWrap.previousElementSibling !== optionsContainer) {
          optionsContainer.insertAdjacentElement('afterend', compositionWrap);
        }
        if (window.initProductInfoTooltips) window.initProductInfoTooltips(compositionWrap.parentElement || document);
        return;
      }

      if (!amountHeading) {
        const previous = optionsContainer.previousElementSibling;
        if (previous && previous.classList.contains('rq-console-bundle__field-heading')) {
          amountHeading = previous;
        } else {
          amountHeading = document.createElement('div');
          amountHeading.className = 'rq-console-bundle__field-heading';
          optionsContainer.insertAdjacentElement('beforebegin', amountHeading);
        }
      }

      amountHeading.classList.add('rq-console-bundle__controller-amount-heading');
      if (!amountHeading.querySelector('[data-bundle-controller-amount-label]')) {
        amountHeading.textContent = '';
        const label = document.createElement('span');
        label.dataset.bundleControllerAmountLabel = 'true';
        label.textContent = 'Amount';
        amountHeading.appendChild(label);
      }
      if (compositionWrap.previousElementSibling !== optionsContainer) {
        optionsContainer.insertAdjacentElement('afterend', compositionWrap);
      }
      if (window.initProductInfoTooltips) window.initProductInfoTooltips(compositionWrap.parentElement || document);
    }

    formatBundleConditionLabel(label) {
      const text = String(label || '').trim();
      if (!text) return '';

      const parts = text.split(/\s+/);
      const grade = parts.shift() || '';
      const remainder = parts.join(' ');
      return remainder
        ? `<strong>${this.escapeHtml(grade)}</strong> ${this.escapeHtml(remainder)}`
        : `<strong>${this.escapeHtml(grade)}</strong>`;
    }

    renderBundleManufacturerBadge(product, extraClass = '') {
      const label = String(product?.manufacturerLabel || '').trim();
      if (!label) return '';

      const officialClass = product?.manufacturerIsOfficial ? ' main-product_manufacturer-badge--official' : '';
      const className = `main-product_manufacturer-badge rq-console-bundle__manufacturer-badge${extraClass}${officialClass}`;
      const icon = product?.manufacturerIsOfficial
        ? `<svg class="main-product_manufacturer-badge-icon" aria-hidden="true" focusable="false" width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/>
            <path d="m9 12 2 2 4-4"/>
          </svg>`
        : '';

      return `<span class="${className}">${icon}${this.escapeHtml(label)}</span>`;
    }

    getBundleUnavailableLabel(product) {
      const type = String(product?.type || product?.productType || '').trim().toLowerCase();
      return ['battery', 'cables & power', 'replacement part'].includes(type)
        ? 'Out of stock'
        : 'Sold out';
    }

    updateConsoleBundleControllerOptions() {
      const totalAvailable = this.getBundleControllerTotalAvailable();
      const maxSelectableCount = totalAvailable === Number.MAX_SAFE_INTEGER ? 4 : Math.max(Math.min(totalAvailable, 4), 0);
      let selectedCount = this.getSelectedBundleControllerCount();
      if (maxSelectableCount > 0 && selectedCount > maxSelectableCount) {
        const fallbackInput = this.querySelector(`[data-bundle-controller-count-select][value="${maxSelectableCount}"]`);
        if (fallbackInput) fallbackInput.checked = true;
        selectedCount = maxSelectableCount;
      }
      this.normalizeControllerCompositionPlacement();
      const options = this.querySelectorAll('[data-bundle-controller-count-option]');
      const optionsContainer = this.querySelector('[data-bundle-controller-options]');
      const compositionWrapEl = this.querySelector('[data-bundle-controller-composition-wrap]');
      const compositionEl = this.querySelector('[data-bundle-controller-composition]');
      const selectedControllerProduct = this.getSelectedBundleControllerProduct();
      const selectedControllerUnavailableLabel = this.getBundleUnavailableLabel(selectedControllerProduct);
      const baseAllocationResult = this.getControllerAllocationResult(1);
      const basePrice = baseAllocationResult.complete ? this.getControllerAllocationTotal(baseAllocationResult.allocations) : 0;
      const selectedAllocationResult = this.getControllerAllocationResult(selectedCount);
      const selectedControllerInput = this.querySelector('[data-bundle-controller-product-select]:checked');
      const rowPatternValue = selectedControllerProduct ? selectedControllerProduct.controllerPatternInRow : false;
      const bundleRowPatternValue = this.getConsoleBundleConfig()?.controllerPatternInRow;
      const rowPatternInputValue = selectedControllerInput ? selectedControllerInput.dataset.controllerPatternInRow : '';
      const normalizedRowPatternValue = String(rowPatternValue || '').trim().toLowerCase();
      const normalizedBundleRowPatternValue = String(bundleRowPatternValue || '').trim().toLowerCase();
      const normalizedRowPatternInputValue = String(rowPatternInputValue || '').trim().toLowerCase();
      const useControllerRowPattern = bundleRowPatternValue === true || normalizedBundleRowPatternValue === 'true' || normalizedBundleRowPatternValue === '1' || rowPatternValue === true || normalizedRowPatternValue === 'true' || normalizedRowPatternValue === '1' || normalizedRowPatternInputValue === 'true' || normalizedRowPatternInputValue === '1';
      const rowPatternDatasetValue = useControllerRowPattern ? 'true' : 'false';

      if (optionsContainer) {
        optionsContainer.dataset.controllerSelectedCount = String(selectedCount);
        optionsContainer.dataset.controllerPatternInRow = rowPatternDatasetValue;
      }

      if (compositionEl) {
        const composition = selectedAllocationResult.complete
          ? this.formatControllerComposition(selectedAllocationResult.allocations)
          : '';
        compositionEl.textContent = composition;
        if (composition) this.ensureControllerCompositionHelp(compositionEl);
        compositionEl.classList.toggle('hidden', !composition);
        if (compositionWrapEl) compositionWrapEl.classList.toggle('hidden', !composition);
      }

      options.forEach((option) => {
        const count = parseInt(option.dataset.playerCount || '1', 10) || 1;
        const unavailable = count > maxSelectableCount;
        const selected = count === selectedCount;
        const input = option.querySelector('[data-bundle-controller-count-select]');
        const card = option.querySelector('[data-bundle-controller-count-card]');
        const thumbs = option.querySelectorAll('[data-bundle-controller-count-thumb]');
        const thumbGroup = option.querySelector('[data-bundle-controller-count-thumbs]');
        const placeholder = option.querySelector('.rq-console-bundle__controller-option-placeholder');
        const oos = option.querySelector('.rq-console-bundle__controller-option-oos');
        const title = option.querySelector('[data-bundle-controller-count-title]');
        const meta = option.querySelector('[data-bundle-controller-count-meta]');
        const allocationResult = this.getControllerAllocationResult(count);

        option.dataset.controllerPatternInRow = rowPatternDatasetValue;
        option.classList.toggle('is-active', selected);
        option.classList.toggle('is-selected', selected);
        option.classList.toggle('is-unavailable', unavailable);
        if (input) input.disabled = unavailable;
        if (card) {
          card.dataset.controllerPatternInRow = rowPatternDatasetValue;
          card.classList.toggle('is-active', selected);
          card.classList.toggle('is-template', false);
          card.classList.toggle('is-preview', false);
          card.classList.toggle('is-unavailable', unavailable);
        }
        if (thumbGroup) {
          thumbGroup.dataset.controllerPatternInRow = rowPatternDatasetValue;
          thumbGroup.classList.toggle('hidden', unavailable);
        }
        thumbs.forEach((thumb) => thumb.classList.toggle('is-hidden', unavailable));
        if (placeholder) placeholder.classList.add('hidden');
        if (oos) oos.classList.toggle('hidden', !unavailable);
        const oosText = oos ? oos.querySelector('.rq-console-bundle__controller-option-oos-text') : null;
        if (oosText) oosText.textContent = selectedControllerUnavailableLabel;
        if (title) {
          title.textContent = `${count} ${count === 1 ? 'Controller' : 'Controllers'}`;
        }
        if (meta) {
          if (allocationResult.complete && !unavailable) {
            const optionPrice = this.getControllerAllocationTotal(allocationResult.allocations);
            const relativePrice = optionPrice - basePrice;
            const absoluteRelativePrice = Math.abs(relativePrice);
            const priceLabel = Shopify.formatMoney(absoluteRelativePrice, window.money_format);
            const formattedPriceLabel = relativePrice === 0
              ? ''
              : `${relativePrice > 0 ? '+' : '-'}${this.escapeHtml(priceLabel)}`;
            meta.innerHTML = formattedPriceLabel
              ? `<span class="rq-console-bundle__controller-option-price">${formattedPriceLabel}</span>`
              : '';
            meta.classList.remove('hidden');
          } else {
            meta.innerHTML = `
              <span class="rq-console-bundle__controller-option-condition">&nbsp;</span>
              <span class="rq-console-bundle__controller-option-price rq-console-bundle__controller-option-price--placeholder">&nbsp;</span>
            `;
            meta.classList.remove('hidden');
          }
        }
      });

    }

    getConditionRank(value) {
      const normalized = String(value || '').trim().toLowerCase();
      if (normalized.startsWith('a+')) return 0;
      if (normalized === 'a' || normalized.startsWith('a ')) return 1;
      if (normalized.startsWith('b')) return 2;
      if (normalized.startsWith('c')) return 3;
      if (normalized.startsWith('f')) return 4;
      return 99;
    }

    getProductOptionIndex(productConfig, matcher) {
      if (!productConfig || !Array.isArray(productConfig.options)) return -1;
      return productConfig.options.findIndex(optionName => matcher.test(String(optionName || '')));
    }

    getLooseConsoleVariants(productConfig = null) {
      const config = this.getConsoleBundleConfig();
      const consoleProduct = productConfig || this.getSelectedBundleConsoleProduct() || config?.console;
      if (!consoleProduct || !Array.isArray(consoleProduct.variants)) return [];

      const typeIndex = this.getProductOptionIndex(consoleProduct, /item type|type|completeness/i);
      const looseValue = (config?.looseValue || 'Loose').toLowerCase();

      return consoleProduct.variants.filter(variant => {
        if (!variant || !Array.isArray(variant.options)) return false;
        if (typeIndex === -1) return true;
        return String(variant.options[typeIndex] || '').toLowerCase() === looseValue;
      });
    }

    getLowestLooseConsolePrice(productConfig) {
      const looseVariants = this.getLooseConsoleVariants(productConfig);
      const availableVariants = looseVariants.filter(variant => variant && variant.available);
      const candidates = availableVariants.length ? availableVariants : looseVariants;
      const prices = candidates
        .map(variant => parseInt(variant && variant.price ? variant.price : '0', 10) || 0)
        .filter(price => price > 0);

      return prices.length ? Math.min(...prices) : 0;
    }

    getLooseConsolePriceForCondition(productConfig, selectedCondition) {
      const condition = String(selectedCondition || '').trim();
      if (!productConfig || !condition) return this.getLowestLooseConsolePrice(productConfig);

      const looseVariants = this.getLooseConsoleVariants(productConfig);
      const conditionIndex = this.getProductOptionIndex(productConfig, /condition|grade/i);
      if (conditionIndex === -1) return this.getLowestLooseConsolePrice(productConfig);

      const exactConditionPrices = looseVariants
        .filter(variant => variant && Array.isArray(variant.options) && String(variant.options[conditionIndex] || '') === condition)
        .map(variant => parseInt(variant && variant.price ? variant.price : '0', 10) || 0)
        .filter(price => price > 0);

      return exactConditionPrices.length ? Math.min(...exactConditionPrices) : this.getLowestLooseConsolePrice(productConfig);
    }

    getConsoleBundleConditionEntries() {
      const consoleProduct = this.getSelectedBundleConsoleProduct();
      if (!consoleProduct) return [];

      const looseVariants = this.getLooseConsoleVariants(consoleProduct);
      const conditionIndex = this.getProductOptionIndex(consoleProduct, /condition|grade/i);
      if (conditionIndex === -1) return [];

      const byLabel = new Map();

      looseVariants.forEach(variant => {
        const label = variant.options[conditionIndex];
        if (!label) return;
        const existing = byLabel.get(label) || { label, available: false, rank: this.getConditionRank(label) };
        if (variant.available) existing.available = true;
        byLabel.set(label, existing);
      });

      return Array.from(byLabel.values()).sort((a, b) => a.rank - b.rank);
    }

    renderConsoleBundleConditionOptions(preferredCondition = null) {
      const container = this.querySelector('[data-bundle-condition-options]');
      const field = this.querySelector('[data-bundle-condition-field]');
      if (!container) return;

      const conditions = this.getConsoleBundleConditionEntries();
      if (!conditions.length) {
        container.innerHTML = '';
        if (field) field.classList.add('hidden');
        return;
      }

      if (field) field.classList.remove('hidden');

      const preferredIndex = preferredCondition
        ? conditions.findIndex(condition => condition.available && String(condition.label) === String(preferredCondition))
        : -1;
      const defaultIndex = preferredIndex !== -1
        ? preferredIndex
        : Math.max(conditions.findIndex(condition => condition.available), 0);

      container.innerHTML = conditions.map((condition, index) => {
        const id = `${this.dataset.section || 'bundle'}-${this.dataset.id || 'product'}-bundle-condition-${index}`;
        const gradeParts = String(condition.label || '').split(' ');
        const gradeLetter = gradeParts[0] || condition.label;
        const gradeLabel = String(condition.label || '').replace(gradeLetter, '').trim();
        return `
          <div class="variant-options-wrap">
            <input
              type="radio"
              id="${id}"
              name="bundle-condition-${this.dataset.id || 'product'}"
              value="${condition.label}"
              ${index === defaultIndex && condition.available ? 'checked' : ''}
              ${condition.available ? '' : 'class="disabled"'}
            >
            <label data-option-name="${condition.label}" class="variant-element_label" for="${id}">
              <span class="variant-element_span">
                <span class="condition-grade-badge">${gradeLetter}</span>${gradeLabel ? `<span class="condition-grade-label">${gradeLabel}</span>` : ''}
              </span>
              <span style="color: #000; background-color: #fff;" class="label-text-sibling ${condition.available ? 'hidden' : 'visually-hidden'}">
                ${window.variantStrings && window.variantStrings.unavailable ? window.variantStrings.unavailable : 'Sold out or unavailable'}
              </span>
            </label>
          </div>
        `;
      }).join('');

      container.querySelectorAll('input[type="radio"]').forEach(input => {
        if (!input.dataset.bundleBound) {
          input.addEventListener('change', () => {
            this.renderConsoleBundleAdvancedOptions(this.getSelectedBundleConsoleAdvancedValue());
            this.updateConsoleBundle();
          });
          input.dataset.bundleBound = 'true';
        }
      });
    }

    getSelectedBundleCondition() {
      const checked = this.querySelector('[data-bundle-condition-options] input[type="radio"]:checked');
      return checked ? checked.value : null;
    }

    getSelectedBundleConsoleAdvancedValue() {
      const checked = this.querySelector('[data-bundle-console-version-options] input[type="radio"]:checked');
      return checked ? checked.value : null;
    }

    getConsoleBundleAdvancedEntries(productConfig = null, selectedCondition = null) {
      const consoleProduct = productConfig || this.getSelectedBundleConsoleProduct();
      if (!consoleProduct) return [];

      const looseVariants = this.getLooseConsoleVariants(consoleProduct);
      const versionIndex = this.getProductOptionIndex(consoleProduct, /^version$/i);
      if (versionIndex === -1) return [];

      const conditionIndex = this.getProductOptionIndex(consoleProduct, /condition|grade/i);
      const byLabel = new Map();

      looseVariants.forEach(variant => {
        if (!variant || !Array.isArray(variant.options)) return;
        const label = variant.options[versionIndex];
        if (!label) return;

        const conditionMatches = !selectedCondition || conditionIndex === -1 || String(variant.options[conditionIndex] || '') === String(selectedCondition);
        const existing = byLabel.get(label) || { label, available: false, price: null };

        if (conditionMatches && variant.available) {
          existing.available = true;
          const price = parseInt(variant.price || '0', 10) || 0;
          if (existing.price === null || price < existing.price) existing.price = price;
        }

        byLabel.set(label, existing);
      });

      return Array.from(byLabel.values());
    }

    renderConsoleBundleAdvancedOptions(preferredValue = null) {
      const field = this.querySelector('[data-bundle-console-advanced-field]');
      const container = this.querySelector('[data-bundle-console-version-options]');
      if (!field || !container) return;

      const selectedCondition = this.getSelectedBundleCondition();
      const entries = this.getConsoleBundleAdvancedEntries(null, selectedCondition);
      if (entries.length <= 1) {
        container.innerHTML = '';
        field.classList.add('hidden');
        return;
      }

      field.classList.remove('hidden');

      const availableEntries = entries.filter(entry => entry.available);
      const preferredEntry = preferredValue
        ? availableEntries.find(entry => String(entry.label) === String(preferredValue))
        : null;
      const defaultEntry = preferredEntry || availableEntries
        .slice()
        .sort((a, b) => ((a.price === null ? Number.MAX_SAFE_INTEGER : a.price) - (b.price === null ? Number.MAX_SAFE_INTEGER : b.price)))[0] || entries[0];

      container.innerHTML = entries.map((entry, index) => {
        const id = `${this.dataset.section || 'bundle'}-${this.dataset.id || 'product'}-bundle-console-version-${index}`;
        const checked = defaultEntry && String(entry.label) === String(defaultEntry.label);
        const unavailableLabel = this.escapeHtml(window.variantStrings && window.variantStrings.unavailable ? window.variantStrings.unavailable : 'Sold out or unavailable');
        return `
          <div class="variant-options-wrap">
            <input
              type="radio"
              id="${this.escapeHtml(id)}"
              name="bundle-console-version-${this.escapeHtml(this.dataset.id || 'product')}"
              value="${this.escapeHtml(entry.label)}"
              ${checked ? 'checked' : ''}
              ${entry.available ? '' : 'class="disabled"'}
            >
            <label data-option-name="${this.escapeHtml(entry.label)}" class="variant-element_label" for="${this.escapeHtml(id)}">
              <span class="variant-element_span">${this.escapeHtml(entry.label)}</span>
              <span style="color: #000; background-color: #fff;" class="label-text-sibling ${entry.available ? 'hidden' : 'visually-hidden'}">
                ${unavailableLabel}
              </span>
            </label>
          </div>
        `;
      }).join('');

      container.querySelectorAll('input[type="radio"]').forEach(input => {
        if (!input.dataset.bundleBound) {
          input.addEventListener('change', () => this.updateConsoleBundle());
          input.dataset.bundleBound = 'true';
        }
      });
    }

    resolveBundleConsoleVariant(productConfig, selectedCondition) {
      if (!productConfig || !selectedCondition) return null;

      const looseVariants = this.getLooseConsoleVariants(productConfig);
      const conditionIndex = this.getProductOptionIndex(productConfig, /condition|grade/i);
      if (conditionIndex === -1) return null;

      const candidates = looseVariants.filter(variant =>
        String(variant.options[conditionIndex] || '') === String(selectedCondition)
      );

      const available = candidates.filter(variant => variant.available);
      if (!available.length) return null;

      const versionIndex = this.getProductOptionIndex(productConfig, /^version$/i);
      const selectedVersion = this.getSelectedBundleConsoleAdvancedValue();
      if (versionIndex !== -1 && selectedVersion) {
        const selectedVersionVariant = available.find(variant =>
          String(variant.options[versionIndex] || '') === String(selectedVersion)
        );
        if (selectedVersionVariant) return selectedVersionVariant;
      }

      return available.sort((a, b) => (a.price || 0) - (b.price || 0))[0];
    }

    resolveBundleComponentVariant(productConfig, selectedVariantId = null, preferredSku = '') {
      if (!productConfig || !Array.isArray(productConfig.variants) || !productConfig.variants.length) return null;

      if (selectedVariantId) {
        const selected = productConfig.variants.find(variant => String(variant.id) === String(selectedVariantId));
        if (selected) return selected;
      }

      if (preferredSku) {
        const bySku = productConfig.variants.find(variant => String(variant.sku || '').trim() === String(preferredSku).trim());
        if (bySku) return bySku;
      }

      const available = productConfig.variants.find(variant => variant.available);
      return available || productConfig.variants[0];
    }

    resolveAvailableBundleComponentVariant(productConfig, selectedVariantId = null, preferredSku = '') {
      if (!productConfig || !Array.isArray(productConfig.variants) || !productConfig.variants.length) return null;

      if (selectedVariantId) {
        const selected = productConfig.variants.find(variant => String(variant.id) === String(selectedVariantId));
        if (selected && selected.available) return selected;
      }

      if (preferredSku) {
        const bySku = productConfig.variants.find(variant => String(variant.sku || '').trim() === String(preferredSku).trim());
        if (bySku && bySku.available) return bySku;
      }

      return productConfig.variants.find(variant => variant && variant.available) || null;
    }

    getFirstAvailableBundleProduct(productConfigs) {
      if (!Array.isArray(productConfigs)) return null;
      return productConfigs.find((productConfig) => this.hasAvailableBundleProductVariant(productConfig)) || null;
    }

    resolveBundleConditionedVariant(productConfig, selectedCondition) {
      if (!productConfig || !Array.isArray(productConfig.variants) || !productConfig.variants.length) return null;

      const conditionIndex = this.getProductOptionIndex(productConfig, /condition|grade/i);
      if (conditionIndex === -1) {
        const variant = this.resolveBundleComponentVariant(productConfig);
        return variant ? { variant, matchedCondition: null, exact: true } : null;
      }

      const availableVariants = productConfig.variants.filter(variant => variant && variant.available && Array.isArray(variant.options));
      if (!availableVariants.length) {
        const variant = this.resolveBundleComponentVariant(productConfig);
        return variant ? { variant, matchedCondition: variant.options && variant.options[conditionIndex] ? variant.options[conditionIndex] : null, exact: false } : null;
      }

      const exact = availableVariants.filter(variant => String(variant.options[conditionIndex] || '') === String(selectedCondition));
      if (exact.length) {
        const variant = exact.sort((a, b) => (a.price || 0) - (b.price || 0))[0];
        return { variant, matchedCondition: variant.options[conditionIndex] || null, exact: true };
      }

      const selectedRank = this.getConditionRank(selectedCondition);
      const fallback = availableVariants
        .map(variant => ({
          variant,
          rank: this.getConditionRank(variant.options[conditionIndex]),
          distance: Math.abs(this.getConditionRank(variant.options[conditionIndex]) - selectedRank)
        }))
        .sort((a, b) => {
          if (a.distance !== b.distance) return a.distance - b.distance;
          if (a.rank !== b.rank) return b.rank - a.rank;
          return (a.variant.price || 0) - (b.variant.price || 0);
        })[0]?.variant || null;

      return fallback ? { variant: fallback, matchedCondition: fallback.options[conditionIndex] || null, exact: false } : null;
    }

    resolveBundleConditionedVariantBySelections(productConfig, selectedCondition, selectedType = null, selectedCoverType = null) {
      if (!productConfig || !Array.isArray(productConfig.variants) || !productConfig.variants.length) return null;

      let filteredVariants = productConfig.variants;
      const typeIndex = this.getProductOptionIndex(productConfig, /item type|type|completeness/i);
      if (selectedType && typeIndex !== -1) {
        filteredVariants = filteredVariants.filter((variant) => {
          return variant && Array.isArray(variant.options) && String(variant.options[typeIndex] || '') === String(selectedType);
        });
      }

      const coverTypeIndex = this.getProductOptionIndex(productConfig, /cover type/i);
      if (selectedCoverType && coverTypeIndex !== -1) {
        filteredVariants = filteredVariants.filter((variant) => {
          return variant && Array.isArray(variant.options) && String(variant.options[coverTypeIndex] || '') === String(selectedCoverType);
        });
      }

      if (!filteredVariants.length) return null;

      return this.resolveBundleConditionedVariant({
        ...productConfig,
        variants: filteredVariants
      }, selectedCondition);
    }

    getVariantAvailableQuantity(variant) {
      if (!variant || !variant.available) return 0;

      if (!variant.inventoryManagement || String(variant.inventoryPolicy || '') === 'continue') {
        return Number.MAX_SAFE_INTEGER;
      }

      const inventoryQuantity = parseInt(variant.inventoryQuantity, 10);
      if (Number.isFinite(inventoryQuantity)) return Math.max(inventoryQuantity, 0);

      return 1;
    }

    resolveBundleConditionedAllocations(productConfig, selectedCondition, requestedQuantity = 1) {
      if (!productConfig || !Array.isArray(productConfig.variants) || !productConfig.variants.length) {
        return { allocations: [], complete: false, remaining: requestedQuantity };
      }

      const normalizedRequestedQuantity = Math.max(parseInt(requestedQuantity, 10) || 0, 0);
      if (!normalizedRequestedQuantity) {
        return { allocations: [], complete: true, remaining: 0 };
      }

      const conditionIndex = this.getProductOptionIndex(productConfig, /condition|grade/i);
      if (conditionIndex === -1) {
        const variant = this.resolveBundleComponentVariant(productConfig);
        return variant
          ? {
            allocations: [{ variant, quantity: normalizedRequestedQuantity, matchedCondition: null, exact: true }],
            complete: true,
            remaining: 0
          }
          : { allocations: [], complete: false, remaining: normalizedRequestedQuantity };
      }

      const availableVariants = productConfig.variants.filter(variant => variant && variant.available && Array.isArray(variant.options));
      if (!availableVariants.length) {
        return { allocations: [], complete: false, remaining: normalizedRequestedQuantity };
      }

      const hasSelectedCondition = selectedCondition !== null && selectedCondition !== undefined && String(selectedCondition).trim() !== '';
      const selectedRank = hasSelectedCondition ? this.getConditionRank(selectedCondition) : null;
      const scoredVariants = availableVariants
        .map(variant => {
          const matchedCondition = variant.options[conditionIndex] || null;
          const rank = this.getConditionRank(matchedCondition);
          return {
            variant,
            matchedCondition,
            exact: hasSelectedCondition && String(matchedCondition || '') === String(selectedCondition || ''),
            rank,
            distance: hasSelectedCondition ? Math.abs(rank - selectedRank) : 0
          };
        })
        .sort((a, b) => {
          if (hasSelectedCondition) {
            if (a.distance !== b.distance) return a.distance - b.distance;
            if (a.rank !== b.rank) return b.rank - a.rank;
          } else if (a.rank !== b.rank) {
            return a.rank - b.rank;
          }
          return (a.variant.price || 0) - (b.variant.price || 0);
        });

      let remaining = normalizedRequestedQuantity;
      const allocations = [];

      scoredVariants.forEach((entry) => {
        if (remaining <= 0) return;

        const availableQuantity = this.getVariantAvailableQuantity(entry.variant);
        if (availableQuantity <= 0) return;

        const quantity = Math.min(remaining, availableQuantity);
        if (quantity <= 0) return;

        allocations.push({
          variant: entry.variant,
          quantity,
          matchedCondition: entry.matchedCondition,
          exact: entry.exact
        });
        remaining -= quantity;
      });

      return {
        allocations,
        complete: remaining === 0,
        remaining
      };
    }

    getConsoleBundleSelection() {
      const config = this.getConsoleBundleConfig();
      if (!config) return null;

      const selectedCondition = this.getSelectedBundleCondition();
      const controllerCount = this.getSelectedBundleControllerCount();
      const selectedConsoleProduct = this.getSelectedBundleConsoleProduct();
      const consoleVariant = this.resolveBundleConsoleVariant(selectedConsoleProduct, selectedCondition);
      const selectedControllerProduct = this.getSelectedBundleControllerProduct();
      const allPowerProducts = Array.isArray(config.powerProducts) ? config.powerProducts : [];
      const powerProducts = this.getVisibleBundlePowerProducts(allPowerProducts);
      const selectedPowerValue = this.getSelectedBundlePowerSelectionValue();
      const selectedPowerProduct = powerProducts.length
        ? (this.hasAvailableBundleProductVariant(powerProducts.find(product => product.handle === selectedPowerValue))
          ? powerProducts.find(product => product.handle === selectedPowerValue)
          : this.getFirstAvailableBundleProduct(powerProducts))
        : null;
      const hasPowerProducts = allPowerProducts.length > 0;
      const hasSinglePowerProduct = hasPowerProducts ? false : this.isValidBundleProductConfig(config.power);
      const powerVariant = selectedPowerProduct
        ? this.resolveAvailableBundleComponentVariant(selectedPowerProduct)
        : (hasSinglePowerProduct ? this.resolveAvailableBundleComponentVariant(config.power, selectedPowerValue) : null);
      const hasControllerProduct = this.isValidBundleProductConfig(selectedControllerProduct);
      const controllerAllocationResult = hasControllerProduct
        ? this.resolveBundleConditionedAllocations(selectedControllerProduct, selectedCondition, controllerCount)
        : { allocations: [], complete: true, remaining: 0 };
      const avProducts = Array.isArray(config.avProducts) ? config.avProducts : [];
      const selectedAvHandle = this.getSelectedBundleAvHandle();
      const selectedAvCandidate = avProducts.find(product => product.handle === selectedAvHandle) || null;
      const selectedAvProduct = this.hasAvailableBundleProductVariant(selectedAvCandidate)
        ? selectedAvCandidate
        : this.getFirstAvailableBundleProduct(avProducts);
      const avVariant = selectedAvProduct ? this.resolveAvailableBundleComponentVariant(selectedAvProduct) : null;
      const controllerAddOnSelections = this.getSelectedBundleControllerAddOnSelections();
      const memoryCardItems = this.getSelectedBundleMemoryCardItems();
      const batteryProduct = this.getSelectedBundleBatteryProduct();
      const batteryVariant = batteryProduct ? this.resolveBundleComponentVariant(batteryProduct) : null;
      const batteryQuantity = this.getSelectedBundleBatteryQuantity();
      const batteryItems = this.getSelectedBundleBatteryItems();
      const consoleAddOnConfig = this.getBundleConsoleAddOnConfig();
      const selectedConsoleAddOnType = this.getSelectedBundleConsoleAddOnType();
      const consoleAddOnMatch = consoleAddOnConfig
        ? this.resolveBundleConditionedVariantBySelections(consoleAddOnConfig, selectedCondition, selectedConsoleAddOnType)
        : null;
      const gameSelections = this.getBundleGameConfigs().map((gameConfig, gameIndex) => {
        const selectedGameType = this.getSelectedBundleGameType(gameIndex);
        const selectedGameCoverType = this.getSelectedBundleGameCoverType(gameIndex);
        const match = this.resolveBundleConditionedVariantBySelections(gameConfig, selectedCondition, selectedGameType, selectedGameCoverType);
        return {
          gameIndex,
          title: gameConfig.title,
          selectedGameType,
          selectedGameCoverType,
          variant: match ? match.variant : null,
          matchedCondition: match ? match.matchedCondition : null,
          exact: match ? match.exact : true
        };
      });
      const otherExtras = this.getBundleOtherExtras().map((extraConfig, extraIndex) => ({
        extraIndex,
        title: extraConfig.title,
        variant: this.resolveAvailableBundleComponentVariant(extraConfig)
      }));
      const optionalAddOns = this.getSelectedBundleOptionalAddOns();

      return {
        quantity: this.getSelectedQuantity(),
        controllerCount,
        selectedCondition,
        selectedConsoleProduct,
        consoleVariant,
        powerVariant,
        hasPower: hasPowerProducts || hasSinglePowerProduct,
        selectedControllerProduct,
        hasController: hasControllerProduct,
        controllerAllocations: controllerAllocationResult.allocations,
        controllerComplete: controllerAllocationResult.complete,
        controllerAddOnSelections,
        avVariant,
        memoryCardItems,
        batteryVariant,
        batteryQuantity,
        batteryItems,
        consoleAddOn: consoleAddOnConfig
          ? {
            title: consoleAddOnConfig.title,
            selectedType: selectedConsoleAddOnType,
            variant: consoleAddOnMatch ? consoleAddOnMatch.variant : null,
            matchedCondition: consoleAddOnMatch ? consoleAddOnMatch.matchedCondition : null,
            exact: consoleAddOnMatch ? consoleAddOnMatch.exact : true
          }
          : null,
        games: gameSelections,
        otherExtras,
        optionalAddOns
      };
    }

    setBundleConditionSummary(target, title, matchedCondition, exact, selectedCondition) {
      if (!target) return;

      if (!matchedCondition) {
        target.innerHTML = title;
        return;
      }

      const summary = `${title} - ${matchedCondition}`;
      if (exact || String(matchedCondition) === String(selectedCondition)) {
        target.innerHTML = summary;
        return;
      }

      target.innerHTML = `${summary}<span class="rq-console-bundle__item-value-note">Closest available match to ${selectedCondition}</span>`;
    }

    getVariantSummaryWithoutCondition(productConfig, variant) {
      if (!variant) return '';

      if (!productConfig || !Array.isArray(productConfig.options) || !Array.isArray(variant.options)) {
        return variant.title || '';
      }

      const conditionIndex = this.getProductOptionIndex(productConfig, /condition|grade/i);
      const summaryParts = variant.options.filter((optionValue, index) => {
        return index !== conditionIndex && String(optionValue || '').trim() !== '';
      });

      if (summaryParts.length) return summaryParts.join(' / ');
      return variant.title || '';
    }

    getVariantConditionValue(productConfig, variant) {
      if (!productConfig || !variant || !Array.isArray(productConfig.options) || !Array.isArray(variant.options)) {
        return null;
      }

      const conditionIndex = this.getProductOptionIndex(productConfig, /condition|grade/i);
      if (conditionIndex === -1) return null;

      return variant.options[conditionIndex] || null;
    }

    getBundleConsoleSummary(productConfig, variant) {
      if (!productConfig || !variant || !Array.isArray(productConfig.options) || !Array.isArray(variant.options)) {
        return this.getVariantSummaryWithoutCondition(productConfig, variant);
      }

      const typeIndex = this.getProductOptionIndex(productConfig, /item type|type|completeness/i);
      if (typeIndex !== -1 && variant.options[typeIndex]) {
        const typeValue = String(variant.options[typeIndex] || '').trim();
        const looseValue = String(this.getConsoleBundleConfig()?.looseValue || 'Loose').trim().toLowerCase();
        return typeValue.toLowerCase() === looseValue ? '' : typeValue;
      }

      return this.getVariantSummaryWithoutCondition(productConfig, variant);
    }

    escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    parseBundleDisplayTitle(rawTitle) {
      const originalTitle = String(rawTitle || '').trim();
      if (!originalTitle) {
        return { baseTitle: originalTitle, styleLabel: null, regionLabel: null, regionFlag: null };
      }

      let workingTitle = originalTitle;
      let regionLabel = null;
      let regionFlag = null;
      const dashChars = '[-\\u2010\\u2011\\u2012\\u2013\\u2014\\u2015\\u2212]';
      const regionMatch = workingTitle.match(new RegExp(`^(.*?)(?:\\s*${dashChars}\\s*)(Japanese|American)\\s*$`, 'i'));
      if (regionMatch) {
        workingTitle = String(regionMatch[1] || '').trim();
        const regionValue = String(regionMatch[2] || '').toLowerCase();
        if (regionValue === 'japanese') {
          regionLabel = 'Japanese';
          regionFlag = 'jp';
        } else if (regionValue === 'american') {
          regionLabel = 'American';
          regionFlag = 'us';
        }
      }

      let styleLabel = null;
      const styleMatch = workingTitle.match(new RegExp(`^(.*?)(?:\\s*${dashChars}\\s*)(.+?)\\s*$`));
      if (styleMatch) {
        const candidateBase = String(styleMatch[1] || '').trim();
        const candidateStyle = String(styleMatch[2] || '').trim();
        if (candidateBase && candidateStyle) {
          workingTitle = candidateBase;
          styleLabel = candidateStyle;
        }
      }

      if (!workingTitle) {
        workingTitle = originalTitle;
        styleLabel = null;
        regionLabel = null;
        regionFlag = null;
      }

      workingTitle = workingTitle
        .replace(/\bConsole Unit Only\b/gi, 'Console')
        .replace(/\bConsole Unit\b/gi, 'Console');

      return {
        baseTitle: workingTitle,
        styleLabel,
        regionLabel,
        regionFlag
      };
    }

    updateBundleDisplayTitle(titleEl, metaEl, rawTitle, suffix = '', options = {}) {
      if (!titleEl) return;

      const parsed = this.parseBundleDisplayTitle(rawTitle);
      titleEl.textContent = parsed.baseTitle || rawTitle || '';
      if (!metaEl) return;

      const metaParts = [];
      const suffixText = String(suffix || '').trim();
      const styleText = parsed.styleLabel
        ? `${parsed.styleLabel}${suffixText ? ` ${suffixText}` : ''}`
        : suffixText;
      const hiddenMetaLabels = Array.isArray(options.hiddenMetaLabels)
        ? options.hiddenMetaLabels.map(label => String(label || '').trim().toLowerCase()).filter(Boolean)
        : [];
      const visibleStyleText = styleText && hiddenMetaLabels.length
        ? styleText
            .split(/\s*[-\u2010\u2011\u2012\u2013\u2014\u2015\u2212]\s*/)
            .map(part => part.trim())
            .filter(part => part && !hiddenMetaLabels.includes(part.toLowerCase()))
            .join(' - ')
        : styleText;

      if (!options.hideStyleLabel && visibleStyleText && !hiddenMetaLabels.includes(visibleStyleText.toLowerCase())) {
        metaParts.push(`<span class="rq-console-bundle__title-meta-line">${this.escapeHtml(visibleStyleText)}</span>`);
      }

      if (parsed.regionLabel && parsed.regionFlag) {
        const flagSrc = parsed.regionFlag === 'jp' ? metaEl.dataset.flagJp : metaEl.dataset.flagUs;
        metaParts.push(`
          <span class="main-product__region-label rq-console-bundle__region-label">
            ${this.escapeHtml(parsed.regionLabel)}
            <span class="product-card__region-badge product-card__region-badge--${parsed.regionFlag}" aria-label="${this.escapeHtml(parsed.regionLabel)}">
              <img src="${this.escapeHtml(flagSrc)}" alt="${this.escapeHtml(parsed.regionLabel)}" width="32" height="24">
            </span>
          </span>
        `);
      }

      metaEl.innerHTML = metaParts.join('');
      metaEl.classList.remove('hidden');
      metaEl.classList.toggle('rq-console-bundle__title-meta--empty', !metaParts.length);
    }

    setBundleAllocationSummary(target, title, allocations, selectedCondition) {
      if (!target) return;

      if (!Array.isArray(allocations) || !allocations.length) {
        target.innerHTML = title;
        return;
      }

      const summaryParts = allocations.map((allocation) => {
        if (!allocation.matchedCondition) return `${allocation.quantity} x ${title}`;
        if (allocations.length === 1 && allocation.quantity === 1) return allocation.matchedCondition;
        return `${allocation.quantity} x ${allocation.matchedCondition}`;
      });

      const hasFallback = allocations.some((allocation) => !allocation.exact && String(allocation.matchedCondition || '') !== String(selectedCondition || ''));
      target.innerHTML = `${title} - ${summaryParts.join(', ')}${hasFallback ? `<span class="rq-console-bundle__item-value-note">Closest available match to ${selectedCondition} where needed</span>` : ''}`;
    }

    setConsoleBundleError(message = '') {
      const errorEl = this.querySelector('[data-bundle-error]');
      if (!errorEl) return;

      if (message) {
        errorEl.textContent = message;
        errorEl.classList.remove('hidden');
      } else {
        errorEl.textContent = '';
        errorEl.classList.add('hidden');
      }
    }

    getConsoleBundleDiscountAmount() {
      return Math.max(parseInt(this.getConsoleBundleConfig()?.discountAmount, 10) || 0, 0);
    }

    getConsoleBundleSubmitText() {
      return this.getConsoleBundleDiscountAmount() > 0 ? 'Add bundle to cart' : 'Add item(s) to cart';
    }

    setConsoleBundleAvailabilityState(isAvailable) {
      const inventoryEls = this.querySelectorAll('[data-request-contents="inventory"]');
      const stockBarEl = this.elements.stockBar;
      const buttonText = isAvailable ? this.getConsoleBundleSubmitText() : 'Sold out';
      const stockLabel = isAvailable ? 'In stock' : 'Out of stock';
      const stockClass = isAvailable ? '--enough-stock' : '--no-stock';

      inventoryEls.forEach((inventoryEl) => {
        inventoryEl.textContent = stockLabel;
        inventoryEl.classList.remove('hidden');
      });

      if (stockBarEl) {
        stockBarEl.classList.remove('hidden');
        stockBarEl.innerHTML = `
          <div class="stock-col_wrapper">
            <strong class="main-product_stock-text">
              <span class="${stockClass}">${stockLabel}</span>
            </strong>
          </div>
        `;
      }

      if (this.elements.addToCartButton && this.elements.addToCartButton.length) {
        this.elements.addToCartButton.forEach((button) => {
          const textEl = button.querySelector('.button--text');
          if (textEl) textEl.textContent = buttonText;
          button.disabled = !isAvailable;
          button.classList.toggle('button--primary', isAvailable);
          button.classList.toggle('button--secondary', !isAvailable);
        });
      }
    }

    updateConsoleBundle() {
      if (!this.hasConsoleBundle()) return;

      this.syncConsoleBundlePowerOptions();
      const selection = this.getConsoleBundleSelection();
      const totalEl = this.querySelector('[data-bundle-total-price]');
      const pagePriceEl = this.querySelector('[data-bundle-page-price]');
      const controlsPriceWrapEl = this.querySelector('[data-bundle-controls-price-wrap]');
      const controlsPriceEl = this.querySelector('[data-bundle-controls-price]');
      const mobileSummaryPriceEl = (this.mobileStickySummaryRoot || this.closest('.main-product'))?.querySelector('[data-mobile-sticky-summary-price]');
      const consoleTitleEl = this.querySelector('[data-bundle-console-title]');
      const consoleTitleMetaEl = this.querySelector('[data-bundle-console-title-meta]');
      const consoleThumbEl = this.querySelector('[data-bundle-console-thumb]');
      const consoleThumbButtonEl = this.querySelector('[data-bundle-console-zoom-trigger]');
      const controllerSummaryEl = this.querySelector('[data-bundle-controller-summary]');
      const controllerTitleMetaEl = this.querySelector('[data-bundle-controller-title-meta]');
      const controllerThumbEls = this.querySelectorAll('[data-bundle-controller-count-thumb]');
      const avThumbEl = this.querySelector('[data-bundle-av-thumb]');
      const cleaningCheckbox = this.querySelector('[data-cleaning-addon]');
      const cleaningVariantPrice = cleaningCheckbox ? parseInt(cleaningCheckbox.dataset.cleaningVariantPrice || '0', 10) || 0 : 0;
      const cleaningEnabled = !!(cleaningCheckbox && cleaningCheckbox.checked && cleaningVariantPrice);
      const optionalExtraItems = this.getOptionalExtraCartItems();
      const memoryCardQtyInputs = this.querySelectorAll('[data-bundle-memory-card-qty-input]');
      const batteryQtyInputs = this.querySelectorAll('[data-bundle-battery-qty-input]');
      const gameConfigs = this.getBundleGameConfigs();
      const hasGames = gameConfigs.length > 0;
      const bundleOtherExtras = this.getBundleOtherExtras();
      const hasOtherExtras = bundleOtherExtras.length > 0;
      const hasConsoleAddOn = !!this.getBundleConsoleAddOnConfig();
      this.updateConsoleBundleControllerOptions();
      const selectedConsoleProduct = selection ? selection.selectedConsoleProduct : this.getSelectedBundleConsoleProduct();

      this.updateBundleDisplayTitle(
        consoleTitleEl,
        consoleTitleMetaEl,
        selectedConsoleProduct?.title || this.getConsoleBundleConfig()?.console?.title || '',
        '',
        {
          hiddenMetaLabels: [this.getConsoleBundleConfig()?.looseValue || 'Loose'],
          hideStyleLabel: this.getBundleConsoleProducts().length > 1
        }
      );
      if (consoleThumbEl) {
        if (selectedConsoleProduct && selectedConsoleProduct.image) {
          consoleThumbEl.src = selectedConsoleProduct.image;
          consoleThumbButtonEl?.classList.remove('hidden');
        } else {
          consoleThumbEl.removeAttribute('src');
          consoleThumbButtonEl?.classList.add('hidden');
        }
      }
      const selectedControllerProduct = this.getSelectedBundleControllerProduct();
      this.updateBundleDisplayTitle(
        controllerSummaryEl,
        controllerTitleMetaEl,
        selectedControllerProduct?.title || this.getConsoleBundleConfig()?.controller?.title || '',
        ''
      );

      if (selectedControllerProduct && controllerThumbEls.length) {
        controllerThumbEls.forEach((thumbEl) => {
          if (!thumbEl) return;
          if (selectedControllerProduct.image) {
            thumbEl.src = selectedControllerProduct.image;
          } else {
            thumbEl.removeAttribute('src');
          }
        });
      }

      selection.controllerAddOnSelections = this.renderBundleControllerAddOns(selection);

      if (memoryCardQtyInputs.length) {
        memoryCardQtyInputs.forEach((input) => this.clampBundleMemoryCardQuantity(input));
      }

      if (batteryQtyInputs.length) {
        batteryQtyInputs.forEach((input) => this.clampBundleBatteryQuantity(input));
      }

      selection.optionalAddOns.forEach((addOnSelection) => {
        const input = this.querySelector(`[data-bundle-optional-addon-select][data-addon-index="${addOnSelection.addOnIndex}"]`);
        const itemEl = input ? input.closest('[data-bundle-optional-addon-item]') : null;
        const isAvailable = !!(addOnSelection.variant && addOnSelection.variant.available);
        if (input) {
          input.disabled = !isAvailable;
          if (!isAvailable && input.checked) {
            input.checked = false;
            addOnSelection.enabled = false;
          }
        }
        if (itemEl) itemEl.classList.toggle('rq-console-bundle__extra-item--disabled', !isAvailable);
      });

      const consoleAddOnRowEl = this.querySelector('[data-bundle-console-addon-row]');
      const consoleAddOnTitleEl = this.querySelector('[data-bundle-console-addon-title]');
      const consoleAddOnTitleMetaEl = this.querySelector('[data-bundle-console-addon-title-meta]');
      const consoleAddOnConditionFieldEl = this.querySelector('[data-bundle-console-addon-condition-field]');
      const consoleAddOnConditionLabelEl = this.querySelector('[data-bundle-console-addon-condition-label]');
      if (consoleAddOnRowEl) {
        if (selection.consoleAddOn) {
          consoleAddOnRowEl.classList.remove('hidden');
          if (consoleAddOnTitleEl) {
            this.updateBundleDisplayTitle(
              consoleAddOnTitleEl,
              consoleAddOnTitleMetaEl,
              selection.consoleAddOn.title || 'Console add-on',
              ''
            );
          }
          if (consoleAddOnConditionFieldEl && consoleAddOnConditionLabelEl) {
            const consoleAddOnCondition = selection.consoleAddOn.matchedCondition || this.getVariantConditionValue(this.getBundleConsoleAddOnConfig(), selection.consoleAddOn.variant);
            if (consoleAddOnCondition) {
              consoleAddOnConditionFieldEl.classList.remove('hidden');
              consoleAddOnConditionLabelEl.innerHTML = this.formatBundleConditionLabel(consoleAddOnCondition);
            } else {
              consoleAddOnConditionFieldEl.classList.add('hidden');
            }
          }
        } else {
          consoleAddOnRowEl.classList.add('hidden');
        }
      }

      this.updateConsoleBundleAvOptionPricing();
      this.updateConsoleBundleConsoleOptionPricing();
      this.updateConsoleBundlePowerOptionPricing();

      if (!selection || !selection.selectedCondition || !selection.consoleVariant || (selection.hasPower && !selection.powerVariant) || (selection.hasController && (!selection.controllerAllocations.length || !selection.controllerComplete)) || (Array.isArray(this.getConsoleBundleConfig().avProducts) && this.getConsoleBundleConfig().avProducts.length && !selection.avVariant) || (hasConsoleAddOn && (!selection.consoleAddOn || !selection.consoleAddOn.variant)) || (hasGames && selection.games.some((game) => !game.variant)) || (hasOtherExtras && selection.otherExtras.some((extra) => !extra.variant))) {
        this.setConsoleBundleError("This bundle isn't available with the options currently selected.");
        this.setConsoleBundleAvailabilityState(false);
        if (totalEl) totalEl.textContent = Shopify.formatMoney(0, window.money_format);
        if (pagePriceEl) pagePriceEl.classList.add('hidden');
        if (controlsPriceWrapEl) controlsPriceWrapEl.classList.add('hidden');
        if (controlsPriceEl) controlsPriceEl.classList.add('hidden');
        if (mobileSummaryPriceEl) mobileSummaryPriceEl.textContent = '';
        return;
      }

      this.setConsoleBundleError('');
      this.setConsoleBundleAvailabilityState(true);
      if (avThumbEl) {
        const avProducts = Array.isArray(this.getConsoleBundleConfig()?.avProducts) ? this.getConsoleBundleConfig().avProducts : [];
        const selectedAvHandle = this.getSelectedBundleAvHandle();
        const selectedAvProduct = avProducts.find(product => product.handle === selectedAvHandle) || avProducts[0] || null;
        if (selectedAvProduct && selectedAvProduct.image) {
          avThumbEl.src = selectedAvProduct.image;
          avThumbEl.classList.remove('hidden');
        } else {
          avThumbEl.classList.add('hidden');
        }
      }

      this.querySelectorAll('[data-bundle-game-row]').forEach((rowEl) => {
        const gameIndex = parseInt(rowEl.dataset.gameIndex || '0', 10) || 0;
        const gameSelection = selection.games.find((game) => game.gameIndex === gameIndex);
        const gameTitleEl = rowEl.querySelector('[data-bundle-game-title]');
        const gameTitleMetaEl = rowEl.querySelector('[data-bundle-game-title-meta]');
        const gameConditionFieldEl = rowEl.querySelector('[data-bundle-game-condition-field]');
        const gameConditionLabelEl = rowEl.querySelector('[data-bundle-game-condition-label]');
        const gameConditionNoteEl = rowEl.querySelector('[data-bundle-game-condition-note]');

        if (gameSelection && gameSelection.variant) {
          rowEl.classList.remove('hidden');
          this.updateBundleDisplayTitle(gameTitleEl, gameTitleMetaEl, gameSelection.title || 'Game', '');
          if (gameConditionFieldEl && gameConditionLabelEl) {
            if (gameSelection.matchedCondition) {
              gameConditionFieldEl.classList.remove('hidden');
              gameConditionLabelEl.innerHTML = this.formatBundleConditionLabel(gameSelection.matchedCondition);
            } else {
              gameConditionFieldEl.classList.add('hidden');
            }
          }
          if (gameConditionNoteEl) {
            gameConditionNoteEl.textContent = '';
            gameConditionNoteEl.classList.add('hidden');
          }
        } else {
          rowEl.classList.add('hidden');
        }
      });

      let total = (selection.consoleVariant.price || 0) + (selection.powerVariant ? selection.powerVariant.price || 0 : 0) + selection.controllerAllocations.reduce((sum, allocation) => sum + ((allocation.variant.price || 0) * allocation.quantity), 0);
      if (selection.avVariant) total += selection.avVariant.price || 0;
      selection.controllerAddOnSelections.forEach((addOnSelection) => {
        if (addOnSelection.enabled && addOnSelection.variant) {
          total += (addOnSelection.variant.price || 0) * selection.controllerCount;
        }
      });
      selection.memoryCardItems.forEach((memoryCardItem) => {
        total += (memoryCardItem.variant.price || 0) * memoryCardItem.quantity;
      });
      selection.batteryItems.forEach((batteryItem) => {
        total += (batteryItem.variant.price || 0) * batteryItem.quantity;
      });
      if (selection.consoleAddOn && selection.consoleAddOn.variant) {
        total += selection.consoleAddOn.variant.price || 0;
      }
      selection.optionalAddOns.forEach((addOn) => {
        if (addOn.enabled && addOn.variant) total += addOn.variant.price || 0;
      });
      selection.games.forEach((game) => {
        if (game.variant) total += game.variant.price || 0;
      });
      selection.otherExtras.forEach((extra) => {
        if (extra.variant) total += extra.variant.price || 0;
      });
      if (cleaningEnabled) total += cleaningVariantPrice;
      total *= selection.quantity;
      total -= (Math.max(parseInt(this.getConsoleBundleConfig()?.discountAmount, 10) || 0, 0) * selection.quantity);
      optionalExtraItems.forEach((optionalExtraItem) => {
        total += optionalExtraItem.price * optionalExtraItem.quantity;
      });
      total = Math.max(total, 0);

      if (totalEl) totalEl.textContent = Shopify.formatMoney(total, window.money_format);
      if (pagePriceEl) {
        pagePriceEl.textContent = Shopify.formatMoney(total, window.money_format);
        pagePriceEl.classList.remove('hidden');
      }
      if (controlsPriceWrapEl) controlsPriceWrapEl.classList.remove('hidden');
      if (controlsPriceEl) {
        controlsPriceEl.textContent = Shopify.formatMoney(total, window.money_format);
        controlsPriceEl.classList.remove('hidden');
      }
      if (mobileSummaryPriceEl) mobileSummaryPriceEl.textContent = Shopify.formatMoney(total, window.money_format);
    }

    logConsoleBundleDebug() {}

    getConsoleBundleDebugSummary(config, selection, items = []) {
      const serializeVariant = (variant) => {
        if (!variant) return null;
        return {
          id: variant.id,
          title: variant.title,
          sku: variant.sku,
          available: variant.available,
          price: variant.price,
          options: variant.options
        };
      };

      return {
        product: {
          handle: this.data?.handle,
          title: this.data?.title,
          pageUrl: window.location.href
        },
        config: {
          bundleTitle: config?.bundleTitle,
          looseValue: config?.looseValue,
          discountAmount: config?.discountAmount,
          console: config?.console ? { handle: config.console.handle, title: config.console.title } : null,
          consoleProducts: Array.isArray(config?.consoleProducts) ? config.consoleProducts.map((product) => ({ handle: product.handle, title: product.title })) : [],
          power: config?.power ? { handle: config.power.handle, title: config.power.title } : null,
          powerProducts: Array.isArray(config?.powerProducts) ? config.powerProducts.map((product) => ({ handle: product.handle, title: product.title })) : [],
          controller: config?.controller ? { handle: config.controller.handle, title: config.controller.title } : null,
          controllerProducts: Array.isArray(config?.controllerProducts) ? config.controllerProducts.map((product) => ({ handle: product.handle, title: product.title })) : [],
          avProducts: Array.isArray(config?.avProducts) ? config.avProducts.map((product) => ({ handle: product.handle, title: product.title })) : [],
          memoryCardProducts: Array.isArray(config?.memoryCardProducts) ? config.memoryCardProducts.map((product) => ({ handle: product.handle, title: product.title })) : [],
          batteryProducts: Array.isArray(config?.batteryProducts) ? config.batteryProducts.map((product) => ({ handle: product.handle, title: product.title })) : [],
          otherExtras: Array.isArray(config?.otherExtras) ? config.otherExtras.map((product) => ({ handle: product.handle, title: product.title })) : []
        },
        selection: selection ? {
          quantity: selection.quantity,
          selectedCondition: selection.selectedCondition,
          selectedConsoleProduct: selection.selectedConsoleProduct ? { handle: selection.selectedConsoleProduct.handle, title: selection.selectedConsoleProduct.title } : null,
          consoleVariant: serializeVariant(selection.consoleVariant),
          hasPower: selection.hasPower,
          powerVariant: serializeVariant(selection.powerVariant),
          hasController: selection.hasController,
          controllerCount: selection.controllerCount,
          controllerComplete: selection.controllerComplete,
          controllerAllocations: selection.controllerAllocations.map((allocation) => ({
            quantity: allocation.quantity,
            exact: allocation.exact,
            matchedCondition: allocation.matchedCondition,
            variant: serializeVariant(allocation.variant)
          })),
          avVariant: serializeVariant(selection.avVariant),
          consoleAddOn: selection.consoleAddOn ? {
            title: selection.consoleAddOn.title,
            selectedType: selection.consoleAddOn.selectedType,
            exact: selection.consoleAddOn.exact,
            matchedCondition: selection.consoleAddOn.matchedCondition,
            variant: serializeVariant(selection.consoleAddOn.variant)
          } : null,
          games: selection.games.map((game) => ({
            title: game.title,
            selectedGameType: game.selectedGameType,
            selectedGameCoverType: game.selectedGameCoverType,
            exact: game.exact,
            matchedCondition: game.matchedCondition,
            variant: serializeVariant(game.variant)
          })),
          otherExtras: selection.otherExtras.map((extra) => ({
            title: extra.title,
            variant: serializeVariant(extra.variant)
          })),
          optionalAddOns: selection.optionalAddOns.map((addOn) => ({
            title: addOn.title,
            enabled: addOn.enabled,
            variant: serializeVariant(addOn.variant)
          })),
          memoryCardItems: selection.memoryCardItems.map((item) => ({
            quantity: item.quantity,
            variant: serializeVariant(item.variant)
          })),
          batteryItems: selection.batteryItems.map((item) => ({
            quantity: item.quantity,
            variant: serializeVariant(item.variant)
          }))
        } : null,
        items: items.map((item) => ({
          role: item.role,
          quantity: item.quantity,
          group: item.group,
          variant: serializeVariant(item.variant)
        }))
      };
    }

    submitConsoleBundle() {
      const config = this.getConsoleBundleConfig();
      const selection = this.getConsoleBundleSelection();
      const hasGames = this.getBundleGameConfigs().length > 0;
      const hasOtherExtras = this.getBundleOtherExtras().length > 0;
      const hasConsoleAddOn = !!this.getBundleConsoleAddOnConfig();
      const cleaningCheckbox = this.querySelector('[data-cleaning-addon]');
      const cleaningVariantId = cleaningCheckbox ? parseInt(cleaningCheckbox.dataset.cleaningVariantId, 10) : 0;
      const cleaningEnabled = !!(cleaningCheckbox && cleaningCheckbox.checked && cleaningVariantId);
      const optionalExtraItems = this.getOptionalExtraCartItems();
      this.logConsoleBundleDebug('submit start', {
        hasConfig: !!config,
        hasSelection: !!selection,
        selectedCondition: selection?.selectedCondition,
        hasConsoleVariant: !!selection?.consoleVariant,
        hasPower: selection?.hasPower,
        hasPowerVariant: !!selection?.powerVariant,
        hasController: selection?.hasController,
        controllerAllocations: selection?.controllerAllocations?.length,
        controllerComplete: selection?.controllerComplete,
        hasAvProducts: Array.isArray(config?.avProducts) && config.avProducts.length > 0,
        hasAvVariant: !!selection?.avVariant,
        hasConsoleAddOn,
        hasConsoleAddOnVariant: !!selection?.consoleAddOn?.variant,
        hasGames,
        missingGameVariants: selection?.games?.filter((game) => !game.variant).map((game) => game.title),
        hasOtherExtras,
        missingOtherExtraVariants: selection?.otherExtras?.filter((extra) => !extra.variant).map((extra) => extra.title),
        cleaningEnabled,
        optionalExtraItems
      });

      if (!config || !selection || !selection.selectedCondition || !selection.consoleVariant || (selection.hasPower && !selection.powerVariant) || (selection.hasController && (!selection.controllerAllocations.length || !selection.controllerComplete)) || (Array.isArray(config.avProducts) && config.avProducts.length && !selection.avVariant) || (hasConsoleAddOn && (!selection.consoleAddOn || !selection.consoleAddOn.variant)) || (hasGames && selection.games.some((game) => !game.variant)) || (hasOtherExtras && selection.otherExtras.some((extra) => !extra.variant))) {
        this.logConsoleBundleDebug('blocked before cart add', this.getConsoleBundleDebugSummary(config, selection));
        this.setConsoleBundleError('Please choose a valid bundle setup before adding to cart.');
        return Promise.resolve({ message: 'Bundle configuration incomplete' });
      }

      const bundleLabel = config.bundleTitle || this.data.title || this.data.handle || 'Bundle';
      const bundleSlug = bundleLabel
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '')
        .slice(0, 24) || 'bundle';
      const bundleId = `${bundleSlug}-${String(Date.now()).slice(-6)}`;
      const bundleDiscountAmount = this.getConsoleBundleDiscountAmount();
      const shouldGroupBundleItems = bundleDiscountAmount > 0;
      const bundleRequiredRoles = ['Console'];
      if (selection.hasPower) bundleRequiredRoles.push('Power cable');
      if (selection.hasController) bundleRequiredRoles.push('Controller');
      if (Array.isArray(config.avProducts) && config.avProducts.length) bundleRequiredRoles.push('AV cable');
      const items = [
        { role: 'Console', variant: selection.consoleVariant, quantity: selection.quantity },
      ];

      selection.controllerAllocations.forEach((allocation) => {
        items.push({
          role: 'Controller',
          variant: allocation.variant,
          quantity: selection.quantity * allocation.quantity
        });
      });

      selection.controllerAddOnSelections.forEach((addOnSelection, index) => {
        if (addOnSelection.enabled && addOnSelection.variant) {
          items.push({
            role: `Controller add-on ${index + 1}`,
            variant: addOnSelection.variant,
            quantity: selection.quantity * selection.controllerCount
          });
        }
      });

      if (selection.avVariant) items.push({ role: 'AV cable', variant: selection.avVariant, quantity: selection.quantity });
      if (selection.powerVariant) items.push({ role: 'Power cable', variant: selection.powerVariant, quantity: selection.quantity });
      selection.memoryCardItems.forEach((memoryCardItem, index) => {
        items.push({ role: `Memory card ${index + 1}`, variant: memoryCardItem.variant, quantity: selection.quantity * memoryCardItem.quantity });
      });
      selection.batteryItems.forEach((batteryItem, index) => {
        items.push({ role: `Battery ${index + 1}`, variant: batteryItem.variant, quantity: selection.quantity * batteryItem.quantity });
      });
      if (selection.consoleAddOn && selection.consoleAddOn.variant) {
        items.push({ role: 'Console add-on', variant: selection.consoleAddOn.variant, quantity: selection.quantity });
      }
      selection.optionalAddOns.forEach((addOn, index) => {
        if (addOn.enabled && addOn.variant) {
          items.push({ role: `Optional add-on ${index + 1}`, variant: addOn.variant, quantity: selection.quantity });
        }
      });
      selection.games.forEach((game, index) => {
        if (game.variant) {
          items.push({ role: `Game ${index + 1}`, variant: game.variant, quantity: selection.quantity });
        }
      });
      selection.otherExtras.forEach((extra, index) => {
        if (extra.variant) {
          items.push({ role: `Extra ${index + 1}`, variant: extra.variant, quantity: selection.quantity });
        }
      });
      if (cleaningEnabled) items.push({ role: 'Cleaning service', variant: { id: cleaningVariantId }, quantity: selection.quantity });
      optionalExtraItems.forEach((optionalExtraItem, index) => {
        items.push({
          role: `Optional extra ${index + 1}`,
          variant: { id: optionalExtraItem.id },
          quantity: optionalExtraItem.quantity,
          group: false
        });
      });

      this.logConsoleBundleDebug('resolved selection and item list', this.getConsoleBundleDebugSummary(config, selection, items));

      const payload = {
        items: items.slice().reverse().map((item) => {
          const cartItem = {
            id: item.variant.id,
            quantity: item.quantity
          };

          if (shouldGroupBundleItems && item.group !== false) {
            cartItem.properties = {
              _bundle_id: bundleId,
              _bundle_name: bundleLabel,
              _bundle_role: item.role,
              _bundle_discount_amount: String(bundleDiscountAmount),
              _bundle_required_roles: bundleRequiredRoles.join('|')
            };
          }

          return cartItem;
        }),
        sections: this.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      };
      const body = JSON.stringify(payload);
      this.logConsoleBundleDebug('cart add payload', payload);

      return fetch(routes.cart_add_url, { ...fetchConfig(), body })
        .then(async (response) => {
          const responsePayload = await response.json().catch(async (error) => {
            const responseText = await response.text().catch(() => '');
            this.logConsoleBundleDebug('cart add response json parse failed', {
              ok: response.ok,
              status: response.status,
              statusText: response.statusText,
              responseText,
              error
            });
            return null;
          });
          if (!response.ok || (responsePayload && responsePayload.message)) {
            console.error('[RQ bundle debug] cart add failed', {
              requestPayload: payload,
              ok: response.ok,
              status: response.status,
              statusText: response.statusText,
              responsePayload
            });
          }
          this.logConsoleBundleDebug('cart add response', {
            ok: response.ok,
            status: response.status,
            statusText: response.statusText,
            payload: responsePayload
          });
          return responsePayload || { message: response.statusText || 'No JSON response', status: response.status };
        })
        .then(responsePayload => {
          this.handleErrors(responsePayload);
          this.logConsoleBundleDebug('after handleErrors', {
            hasError: this.hasError,
            responseMessage: responsePayload?.message,
            responseDescription: responsePayload?.description,
            hasSections: !!responsePayload?.sections,
            sectionKeys: responsePayload?.sections ? Object.keys(responsePayload.sections) : []
          });
          return responsePayload;
        })
        .catch(error => {
          console.error('[RQ] console bundle add error', error);
          this.setConsoleBundleError('We could not add this bundle to cart. Please try again.');
          throw error;
        });
    }
    
    addCleaningAddon(cleaningParentId = ''){
      const checkbox = this.querySelector('[data-cleaning-addon]');
      if(!checkbox || !checkbox.checked) return Promise.resolve(null);
      const variantId = parseInt(checkbox.dataset.cleaningVariantId, 10);
      if(!variantId) return Promise.resolve(null);
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      if(this.data && this.data.title) formData.append('properties[For]', this.data.title);
      if(this.currentVariant && this.currentVariant.title) formData.append('properties[Variant]', this.currentVariant.title);
      if(cleaningParentId) formData.append('properties[_cleaning_parent_id]', cleaningParentId);
      config.body = formData;

      return fetch(`${routes.cart_add_url}`, config)
      .then(async (response) => {
        const payload = await response.json().catch(() => null);
        if(!response.ok || (payload && payload.message)) {
          console.error('[RQ] cleaning addon cart error:', payload || response.statusText);
          return null;
        }
        return payload;
      });
    }

    getOptionalExtraCartItems() {
      return Array.from(this.querySelectorAll('[data-optional-extra-select]:checked')).map((selected) => {
        if (!selected || !selected.value || selected.disabled) return null;

        const variantId = parseInt(selected.dataset.optionalExtraVariantId || selected.value, 10);
        if (!variantId) return null;

        const selectedCard = selected.closest('.rq-optional-extras__option');
        const qtyInput = selectedCard ? selectedCard.querySelector('[data-optional-extra-qty-input]') : null;
        const defaultQuantity = Math.max(parseInt(selected.dataset.optionalExtraDefaultQty || '1', 10) || 1, 1);
        const quantity = qtyInput ? this.clampOptionalExtraQuantity(qtyInput) : defaultQuantity;
        const price = Math.max(parseInt(selected.dataset.optionalExtraVariantPrice || '0', 10) || 0, 0);

        return {
          id: variantId,
          quantity,
          price,
          productTitle: selected.dataset.optionalExtraProductTitle || '',
          variantTitle: selected.dataset.optionalExtraVariantTitle || ''
        };
      }).filter(Boolean);
    }

    getOptionalExtraCartItem() {
      return this.getOptionalExtraCartItems()[0] || null;
    }

    clampOptionalExtraQuantity(input) {
      if (!input) return 1;
      const min = Math.max(parseInt(input.min || '1', 10) || 1, 1);
      const maxRaw = parseInt(input.max || '', 10);
      const hasMax = input.hasAttribute('max') && Number.isFinite(maxRaw) && maxRaw >= min;
      const max = hasMax ? maxRaw : Number.MAX_SAFE_INTEGER;
      let value = parseInt(input.value || String(min), 10);
      if (!Number.isFinite(value)) value = min;
      value = Math.max(Math.min(value, max), min);
      input.value = String(value);
      const stepper = input.closest('[data-optional-extra-qty-stepper]');
      if (stepper) {
        const decrement = stepper.querySelector('[data-optional-extra-qty-decrement]');
        const increment = stepper.querySelector('[data-optional-extra-qty-increment]');
        if (decrement) decrement.disabled = value <= min;
        if (increment) increment.disabled = hasMax && value >= max;
      }
      return value;
    }

    stepOptionalExtraQuantity(button) {
      const stepper = button.closest('[data-optional-extra-qty-stepper]');
      const input = stepper ? stepper.querySelector('[data-optional-extra-qty-input]') : null;
      if (!input) return;
      const current = this.clampOptionalExtraQuantity(input);
      const direction = button.matches('[data-optional-extra-qty-increment]') ? 1 : -1;
      input.value = String(current + direction);
      this.clampOptionalExtraQuantity(input);
      this.updateOptionalExtraCardPrice(input);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    updateOptionalExtraCardPrice(input) {
      const card = input ? input.closest('.rq-optional-extras__card') : null;
      const priceEl = card ? card.querySelector('[data-optional-extra-price]') : null;
      if (!priceEl) return;

      const unitPrice = Math.max(parseInt(priceEl.dataset.optionalExtraUnitPrice || '0', 10) || 0, 0);
      const quantity = this.clampOptionalExtraQuantity(input);
      priceEl.textContent = `+ ${Shopify.formatMoney(unitPrice * quantity, window.money_format)}`;
    }

    addOptionalExtra(){
      const items = this.getOptionalExtraCartItems();
      if(!items.length) return Promise.resolve(null);

      const body = JSON.stringify({
        items: items.map((item) => ({
          id: item.id,
          quantity: item.quantity,
          properties: {
            ...(this.data && this.data.title ? { For: this.data.title } : {}),
            ...(this.currentVariant && this.currentVariant.title ? { Variant: this.currentVariant.title } : {})
          }
        })),
        sections: this.getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname
      });

      return fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then(async (response) => {
        const payload = await response.json().catch(() => null);
        if(!response.ok || (payload && payload.message)) {
          console.error('[RQ] optional extra cart error:', payload || response.statusText);
          return null;
        }
        return payload;
      });
    }

    onsubmitHandler(){
      event.preventDefault();
      this.updateSubmitButton(false);
      this.setLoaderActivity(true);

      if (this.hasConsoleBundle()) {
        this.logConsoleBundleDebug('onsubmit console bundle branch', {
          sectionsToRender: this.getSectionsToRender().map((section) => section.id),
          cartDrawerPresent: !!this.elements.cartShower,
          cartInventoryOrganizerPresent: !!this.elements.cartInvertoryOrganizer
        });
        this.submitConsoleBundle()
        .then((response) => {
          this.hasError = !!(response && (response.message || response.errors || (response.status && response.status >= 400)));
          this.logConsoleBundleDebug('submit promise resolved', {
            hasError: this.hasError,
            responseMessage: response?.message,
            responseErrors: response?.errors,
            responseDescription: response?.description,
            responseStatus: response?.status,
            hasSections: !!response?.sections,
            sectionKeys: response?.sections ? Object.keys(response.sections) : []
          });
          if(!this.hasError && response && response.sections){
            this.getSectionsToRender().forEach((section => {
              const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
              this.logConsoleBundleDebug('render returned cart section', {
                sectionId: section.id,
                selector: section.selector,
                sectionElementFound: !!sectionElement,
                returnedSectionPresent: !!response.sections[section.id]
              });
              if(sectionElement && response.sections[section.id]) sectionElement.innerHTML = this.getSectionInnerHTML(response.sections[section.id], section.selector);
            }));
          }
        })
        .catch((e) => {
          console.error('[RQ bundle debug] submit promise rejected', e);
          this.hasError = true;
        })
        .finally(() => {
          this.logConsoleBundleDebug('submit finally', {
            hasError: this.hasError,
            cartDrawerPresent: !!this.elements.cartShower,
            cartInventoryOrganizerPresent: !!this.elements.cartInvertoryOrganizer
          });
          this.setLoaderActivity(false);
          this.updateSubmitButton(true);
          if(!this.hasError){
            this.logConsoleBundleDebug('opening cart drawer after bundle add');
            this.elements.cartInvertoryOrganizer.updateBubbleStatus();
            if(this.elements.cartShower) this.elements.cartShower.open();
          }
        });
        return;
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.elements.submitFormElem);
      const cleaningCheckbox = this.querySelector('[data-cleaning-addon]');
      const cleaningVariantId = cleaningCheckbox ? parseInt(cleaningCheckbox.dataset.cleaningVariantId, 10) : 0;
      const cleaningParentId = cleaningCheckbox && cleaningCheckbox.checked && cleaningVariantId ? `cleaning-${Date.now()}-${Math.random().toString(36).slice(2, 10)}` : '';
      if(cleaningParentId) formData.append('properties[_cleaning_parent_id]', cleaningParentId);
      formData.append('sections', this.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        this.hasError = false;
        this.handleErrors(response);

        publish(PUB_SUB_EVENTS.cartError, {source: `.${this.dataPrefix}form:not([class*="installment"]):not([action*="contact"])`, productVariantId: formData.get('id'), errors: response.description, message: response.message});

        const cartItemQty = response.quantity;
        this.elements.cartInvertoryOrganizer.setCartUpdates(cartItemQty, this.elements.inCartElem);
        const minCartElem = document.querySelectorAll('checkout-min');
        if(minCartElem.length > 0){
          minCartElem.forEach(checkoutMin => {
            checkoutMin.removeListener();
          });
        }

        if(this.hasError) return response;
        return this.addCleaningAddon(cleaningParentId)
          .catch((error) => {
            console.error('[RQ] cleaning addon follow-up error:', error);
            return null;
          })
          .then((cleaningResponse) => {
            const latestResponse = cleaningResponse && cleaningResponse.sections ? cleaningResponse : response;
            return this.addOptionalExtra()
              .catch((error) => {
                console.error('[RQ] optional extra follow-up error:', error);
                return null;
              })
              .then((optionalExtraResponse) => {
                if(optionalExtraResponse && optionalExtraResponse.sections) return optionalExtraResponse;
                return latestResponse;
              });
          });
      })
      .then((response) => {
        if(!this.hasError && response && response.sections){
          this.getSectionsToRender().forEach((section => {
            const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
            if(sectionElement && response.sections[section.id]) sectionElement.innerHTML = this.getSectionInnerHTML(response.sections[section.id], section.selector);
          }));
        }
      })
      .catch((e) => {
        console.error(e);
        this.hasError = true;
      })
      .finally(() => {
        if(this.elements.quantityInput){
          var currPrice = this.getCurrentPriceData();
          this.elements.quantityInput.resetDefaults(currPrice);
        }
        const minCartElem = document.querySelectorAll('checkout-min');
        if(minCartElem.length > 0){
          minCartElem.forEach(checkoutMin => {
            checkoutMin.onCheck();
            checkoutMin.initialize();
          });
        }
        this.updateSubmitButton(true);
        this.setLoaderActivity(false);
        if(!this.hasError){
          this.elements.cartInvertoryOrganizer.updateBubbleStatus();
          const recipientForm = this.querySelector('recipient-form');
          if(recipientForm) recipientForm.clearInputFields(true);
          
          const isMainCart = document.getElementById('main-cart');
          const isCartEmpty = document.querySelector('.empty_case');
          if(isMainCart){
            const cartItemRow = document.querySelector('cart-item-row');
            const cartItemRowId = cartItemRow.dataset.id;
            const cartItemRowQty = cartItemRow.input.value;
            
            if(isCartEmpty){
              cartItemRow.setRenderChanges(cartItemRowId, cartItemRowQty, true);
              
              return;
            }
            if(cartItemRow) cartItemRow.setRenderChanges(cartItemRowId, cartItemRowQty);
            
            return;
          }
          if(this.elements.cartShower) this.elements.cartShower.open();
        }
      });
    }
    
    handleErrors(response){
      if(!this.elements.errorsContainer) return;
      if(response.quantity === 0) return this.hasError = true;
      
      this.elements.errorsContainer.classList.add('hidden');
      this.elements.errorsContainer.innerText = '';
      const recipientForm = this.querySelector('recipient-form');
      if(recipientForm) recipientForm.clearErrorMessage();
      
      if(response.message){
        this.hasError = true;
        let message = response.description;
        
        if(typeof(response.description) === 'object'){
          message = response.message;
          if(recipientForm) recipientForm.displayErrorMessage(message, response.errors);
        }
        
        this.elements.errorsContainer.classList.remove('hidden');
        this.elements.errorsContainer.innerText = message;
        
        if(!this.classList.contains('main-product-card')){
          setTimeout(() => {
            this.elements.errorsContainer.classList.add('hidden');
          }, 3500);
        }
      }
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-inventory-organizer',
          section: 'cart-inventory-organizer',
          selector: 'cart-inventory-organizer'
        },
        {
          id: 'cart-items',
          selector: '#cart-items',
          section: 'cart-items'
        }
      ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser() .parseFromString(html, 'text/html') .querySelector(selector).innerHTML;
    }

    onVariantColorChange(backflow = false){
      if(backflow){
        const colorsArr = Array.from(this.elements.variantColorsContainer.querySelectorAll('input'));
        colorsArr.map((input, index) => {
          const ids = input.id.replace('-colors', '');
          const correspondingElement = document.querySelector(`#${ids}`);
          const labelText = colorsArr[index].querySelector('.label-text-sibling');
          if(correspondingElement.checked) colorsArr[index].checked = true;
          if(correspondingElement.classList.contains('disabled')){
            colorsArr[index].classList.add('disabled');
            if(labelText){
              labelText.classList.remove('hidden');
              labelText.classList.add('visually-hidden');
            }
          } else {
            colorsArr[index].classList.remove('disabled');
            if(labelText){
              labelText.classList.add('hidden');
              labelText.classList.remove('visually-hidden');
            }
          }
        });
        return;
      }
      const inputCurr = event.target;
      const inputRef = inputCurr.id;
      const inputId = inputRef.endsWith('-colors') ? inputRef.slice(0, -7) : null;
      if(!inputId) return
      document.getElementById(inputId).checked = true;
      this.onVariantChange();
    }
    
    onVariantChange(){
      this.setLoaderActivity(true);
      this.getSelectedVarintOptions();
      this.selectedVariantData();

      if(this.currentVariant) {
        publish(PUB_SUB_EVENTS.variantChange, {
          variant: this.currentVariant,
          options: this.options,
          source: this
        });
      }

      if(this.currentVariant === undefined){
        this.updateVariantStatuses();
        this.setUnavailableStatuses(true);
      } else{
        this.updateVariantInput();
        this.updateVariantSku();
        this.updateVariantStatuses();
        this.setUnavailableStatuses(false);
        this.updateMedia();
        this.setQtyRules();
        this.updateShareUrl();
        this.renderChangesUpdates();
        this.updateURL();
      }
      
      if(this.dataset.exceptQuery){
        this.setAttribute('data-bundle-included', true);
        this.onBundleCheckLabel();
      }

      if(this.dataset.swatchImages === 'true') this.setSwatchImages();
      this.updateConsoleBundle();
    }
    
    setUnavailableStatuses(status){
      if(status){
        if(this.elements.priceElem) this.elements.priceElem.classList.add('hidden');
        if(this.elements.saleTag) this.elements.saleTag.classList.add('hidden');
        if(this.elements.priceDup) this.elements.priceDup.classList.add('hidden');
        if(this.elements.cardInventory){
          this.elements.cardInventory.innerHTML = '';
          this.elements.cardInventory.parentElement.classList.add('hidden');
          this.elements.cardInventory.classList.add('hidden');
        }
        if(this.elements.inventory) this.elements.inventory.classList.add('hidden');
        if(this.elements.stockBar){
          this.elements.stockBar.classList.add('hidden');
          this.elements.stockBar.innerHTML = '';
        }
        if(this.elements.pickUpAvailability) this.elements.pickUpAvailability.classList.add('hidden');
        if(this.elements.unitPrice) this.elements.unitPrice.classList.add('hidden');
        if(this.elements.quantityInput) this.elements.quantityInput.toggleSubtotal(false);
        this.updateSubmitButton(false, window.variantStrings.unavailable);
        this.setLoaderActivity(false);
      } else{
        if(this.elements.priceElem) this.elements.priceElem.classList.remove('hidden');
        if(this.elements.saleTag) this.elements.saleTag.classList.remove('hidden');
        if(this.elements.priceDup) this.elements.priceDup.classList.remove('hidden');
        if(this.elements.pickUpAvailability) this.elements.pickUpAvailability.classList.remove('hidden');
        if(this.elements.unitPrice) this.elements.unitPrice.classList.remove('hidden');
        if(this.elements.quantityInput) this.elements.quantityInput.toggleSubtotal(true);
      }
    }
    
    onBundleCheckLabel(){
      this.elements.bundleCheckCardLabel.classList.add('--disabled');
      if(!this.currentVariant){
        this.getSelectedVarintOptions();
        this.selectedVariantData();
      }
      if(this.currentVariant && this.currentVariant.available) this.elements.bundleCheckCardLabel.classList.remove('--disabled');
      
      if (!this.currentVariant){
        this.currentVariant = null;
        const checkRows = this.querySelector(this.staticSelectors.variantRows);
        
        if(this.data.available && !checkRows){
          this.elements.bundleCheckCardLabel.classList.remove('--disabled');
        }
      }
      
      if(!this.data.requires_selling_plan){
        if(this.dataset.bundleIncluded === 'true'){
          this.setAttribute('data-bundle-included', false);
        
        } else{
          this.setAttribute('data-bundle-included', true);
          this.elements.bundleCheckCardLabel.classList.remove('--disabled');
        }
      } else{
        this.setAttribute('data-bundle-included', false);
        this.elements.bundleCheckCardLabel.classList.add('--disabled');
      }
      
      const bundleContainer = document.querySelector('bundle-product-wrapper');
      bundleContainer.initBundleCheck();
    }
    
    renderChangesUpdates(){
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.id}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        
        if(this.elements.unitPrice) this.setSectionRenderChanges(html, this.staticSelectors.unitPricing, this.elements.unitPrice);
        if(this.elements.priceElem) {
          this.setSectionRenderChanges(html, this.staticSelectors.price, this.elements.priceElem);
          this.syncMainProductPriceFromVariant(this.elements.priceElem);
        }
        if(this.elements.priceDup) this.setSectionRenderChanges(html, this.staticSelectors.price, this.elements.priceDup);
        if(this.elements.saleTag) this.setSectionRenderChanges(html, this.staticSelectors.priceTag, this.elements.saleTag);
        
        if(this.elements.inventory){
          if(this.currentVariant.inventory_management === 'shopify'){
            this.elements.inventory.classList.remove('hidden');
          
          } else{
            this.elements.inventory.classList.add('hidden');
          }
          
          this.setSectionRenderChanges(html, this.staticSelectors.inventory, this.elements.inventory);
        }
        if(this.elements.stockBar){
          if(this.currentVariant.inventory_management === 'shopify'){
            this.elements.stockBar.classList.remove('hidden');
            
            const qty = this.currentVariant.inventory_quantity;
            const backordered = this.currentVariant.inventory_policy === 'continue';
            let stockLabel = '';
            let stockClass = '';
            
            if(backordered){
              stockLabel = 'In stock';
              stockClass = '--enough-stock';
            } else if(qty < 1){
              stockLabel = 'Out of stock';
              stockClass = '--no-stock';
            } 
            // else if(qty <= 1){
            //   stockLabel = 'Low stock';
            //   stockClass = '--low-stock';
            // } 
            else {
              stockLabel = 'In stock';
              stockClass = '--enough-stock';
            }
            
            this.elements.stockBar.innerHTML = `
              <div class="stock-col_wrapper">
                <strong class="main-product_stock-text">
                  <span class="${stockClass}">${stockLabel}</span>
                </strong>
              </div>
            `;
          } else{
            this.elements.stockBar.classList.add('hidden');
            this.elements.stockBar.innerHTML = '';
          }
        }
        if(this.elements.cardInventory){
          if(this.currentVariant.inventory_management === 'shopify'){
            this.elements.cardInventory.parentElement.classList.remove('hidden');
            this.elements.cardInventory.classList.remove('hidden');
          
          } else{
            this.elements.cardInventory.parentElement.classList.add('hidden');
            this.elements.cardInventory.classList.add('hidden');
          }
          this.setSectionRenderChanges(html, this.staticSelectors.inventCard, this.elements.cardInventory);
        }
        if(this.elements.pickUpAvailability) this.setSectionRenderChanges(html, this.staticSelectors.pickUp, this.elements.pickUpAvailability);
      })
      .catch((e) => {
        console.error(e);
        throw e;
      })
      .finally(() => {
        if(this.elements.pickUpAvailability){
          const scheme = this.querySelector('[data-pickup-bg-scheme]');
          const drawer = this.querySelector('.modal-component--pickup-drawer');
          if(drawer) drawer.classList.add(scheme.dataset.pickupBgScheme);
        }
        if(this.elements.quantityInput){
          this.elements.quantityInput.validateQtyRules(this.currentVariant.quantity_rule, this.currentVariant);
        }
        
        // if(this.elements.inventory) this.elements.inventory.classList.remove('--show-loader');
        // if(this.elements.priceElem) this.elements.priceElem.classList.remove('--show-loader');
        // if(this.elements.saleTag) this.elements.saleTag.classList.remove('--show-loader');
        this.setLoaderActivity(false);
      });
    }
    
    setSectionRenderChanges(newHtml, name, selector){
      const newSource = newHtml.querySelector(name);
      selector.innerHTML = newSource.innerHTML;
    }

    syncMainProductPriceFromVariant(priceContainer){
      if(!this.classList.contains('main-product-card') || !priceContainer || !this.currentVariant) return;
      if(priceContainer.querySelector('[data-bundle-page-price]')) return;

      const mainPrice = priceContainer.querySelector('.main-price');
      if(!mainPrice) return;

      mainPrice.textContent = Shopify.formatMoney(this.currentVariant.price, window.money_format);
    }
    
    setQtyRules(variantId = null){
      if(variantId){
        this.currentVariant = {};
        this.currentVariant.id = parseInt(variantId);
      }
      
      if(!this.currentVariant.id) return;
      
      const activeInCart = this.elements.cartInvertoryOrganizer.getPurposalDetails(this.currentVariant.id);
      if(activeInCart){
        this.elements.cartInvertoryOrganizer.setCartUpdates(activeInCart.quantity, this.elements.inCartElem);
      
      } else{
        this.elements.cartInvertoryOrganizer.setCartUpdates(0, this.elements.inCartElem);
      }
    }
    
    getSelectedVarintOptions(){
      if(this.variantDataCase == 'radio'){
        this.variantRows = this.querySelectorAll(`product-card-variants ${this.staticSelectors.variantRows}`);

        // Build a mapping from each DOM row index to its correct index in variant.options.
        // DOM order is: standard options (admin order minus advanced), then advanced options.
        // variant.options follows the Shopify admin order, which may differ.
        if (this.data && this.data.options) {
          const advancedNames = Array.from(this.querySelectorAll('fieldset[data-option-name]')).map(f => f.dataset.optionName);
          const standardNames = this.data.options.filter(n => !advancedNames.includes(n));
          const domOrderNames = [...standardNames, ...advancedNames];
          this.variantOptionIndices = domOrderNames.map(name => this.data.options.indexOf(name));
        } else {
          this.variantOptionIndices = Array.from(this.variantRows).map((_, i) => i);
        }

        const variantDataRows = Array.from(this.variantRows);
        this.options = variantDataRows.map((rowSet) => {
          return Array.from(rowSet.querySelectorAll(this.staticSelectors.inputRadio)).find((radio) => radio.checked).value;
        });

        return;
      }
    }

    selectedVariantData() {
      if(this.variantRows.length == 1){
        const currentVariants = this.data.variants.filter((variant) => variant.options.find((x) => x === this.options[0]));
        this.currentVariant = currentVariants.find((variant) => variant.available)
        if(!this.currentVariant) this.currentVariant = currentVariants[0];

        return;
      }

      // Use the admin-order index mapping computed in getSelectedVarintOptions.
      // This handles products where Shopify admin option order differs from DOM row order
      // (e.g. Version is the first admin option but rendered last in the DOM).
      const indices = this.variantOptionIndices || this.options.map((_, i) => i);

      this.currentVariant = this.data.variants.find(variant => {
        if(!variant || !Array.isArray(variant.options)) return false;
        return this.options.every((opt, i) => opt === variant.options[indices[i]]);
      });

      // If no exact match, OR if the match is sold out and there are advanced options,
      // auto-select the best available advanced option value (Version/Cover Type) for
      // the current standard options (Type + Condition).
      const hasAdvanced = this.querySelectorAll('fieldset[data-option-name]').length > 0;
      if (!this.currentVariant || (!this.currentVariant.available && hasAdvanced)) {
        const advancedFieldsets = Array.from(this.querySelectorAll('fieldset[data-option-name]'));
        if (advancedFieldsets.length > 0) {
          const standardCount = this.options.length - advancedFieldsets.length;
          const standardOptions = this.options.slice(0, standardCount);
          const standardIndices = indices.slice(0, standardCount);

          const standardMatches = this.data.variants.filter(variant => {
            if(!variant || !Array.isArray(variant.options)) return false;
            return standardOptions.every((opt, i) => opt === variant.options[standardIndices[i]]);
          });

          if (standardMatches.length > 0) {
            const best = standardMatches.find(v => v.available) || standardMatches[0];

            advancedFieldsets.forEach((fieldset, i) => {
              const adminIdx = indices[standardCount + i];
              if(!Array.isArray(best.options)) return;
              const targetValue = best.options[adminIdx];
              if(typeof targetValue === 'undefined') return;
              const targetRadio = fieldset.querySelector(`input[value="${CSS.escape(targetValue)}"]`);
              if (targetRadio && !targetRadio.checked) targetRadio.checked = true;
            });

            this.options = Array.from(this.variantRows).map(rowSet =>
              Array.from(rowSet.querySelectorAll('input[type="radio"]')).find(r => r.checked).value
            );

            this.currentVariant = this.data.variants.find(variant => {
              if(!variant || !Array.isArray(variant.options)) return false;
              return this.options.every((opt, i) => opt === variant.options[indices[i]]);
            });
          }
        }
      }
    }

    updateVariantInput() {
      this.elements.formElems.forEach((productForm) => {
        const input = productForm.querySelector(this.staticSelectors.inputVariantId);
        input.value = this.currentVariant.id;
        // input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    updateVariantSku() {
      if(!this.elements.sku || !this.currentVariant) return;
      const skuParent = this.querySelector('[data-parent="sku"]');
      
      if(!this.currentVariant.sku){
        skuParent.classList.add('hidden');
      
      } else{
        skuParent.classList.remove('hidden');
      }
      
      this.elements.sku.textContent = this.currentVariant.sku;
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media){
        if(this.elements.staticGalleryItem) this.elements.staticGalleryItem.classList.remove('--show-only-variant');
        if(this.querySelector(this.staticSelectors.staticGalleryVariantItem)) this.querySelector(this.staticSelectors.staticGalleryVariantItem).classList.remove('--active');
        
        return
      }
      
      if(this.currentVariant.featured_media && this.dataset.mediaGallery == 'static'){
        const originalUrl = this.currentVariant.featured_media.preview_image.src;
        let imageUrl = originalUrl.replace(/^(http:|https:)/, "");
        imageUrl += `&width=${this.currentVariant.featured_media.preview_image.width}`;
        const newImageUrl = imageUrl;
        const imageWidth = this.currentVariant.featured_media.preview_image.width;
        const imageHeight = this.currentVariant.featured_media.preview_image.height;
        const imageRatio = this.currentVariant.featured_media.preview_image.aspect_ratio;
        
        if(!this.elements.staticGalleryItem || !this.querySelector(this.staticSelectors.staticGalleryVariantItem)) return;

        const mediaContainer = this.elements.staticGalleryItem;
        this.querySelectorAll(this.staticSelectors.staticGalleryVariantItem).forEach((item) => item.classList.remove('--active'));
        const imageContainer = this.querySelector(`${this.staticSelectors.staticGalleryVariantItem}[data-media-id="${this.currentVariant.featured_media.id}"]`) || this.querySelector(this.staticSelectors.staticGalleryVariantItem);
        const imageSrc = imageContainer.querySelector('img');
        
        imageSrc.setAttribute('src', newImageUrl);
        const srcset = imageSrc.srcset;
        const newSrcset = `${newImageUrl}&width=576 576w, ${newImageUrl}&width=768 768w, ${newImageUrl}&width=992 992w, ${newImageUrl}&width=1200 1200w, ${newImageUrl}&width=1440 1440w, ${newImageUrl}&width=1946 1946w`;
        imageSrc.setAttribute('srcset', newSrcset);
        imageSrc.setAttribute('width', imageWidth);
        imageSrc.setAttribute('height', imageHeight);
        
        mediaContainer.classList.add('--show-only-variant');
        imageContainer.style.setProperty('--aspect-ratio', imageRatio);
        imageContainer.classList.add('--active');
        
        return;
      }

      if(this.elements.thumbnailGallery) {
        const splideMediaId = this.currentVariant.featured_media.id;
        this.setActiveSplideThumbnail(this.elements.thumbnailGallery, splideMediaId);
      }
      if(this.elements.galleryThumbnails) this.elements.galleryThumbnails.classList.remove('--variant-thumb-active');
      
      if(this.currentVariant.featured_media && this.elements.galleryThumbnails){
        this.elements.galleryThumbnails.classList.add('--variant-thumb-active');
        
        this.elements.statckedThumbnails.forEach(thumb => {
          thumb.classList.remove('--active-thumb');
          
          if(thumb.dataset.mediaId == this.currentVariant.featured_media.id){
            thumb.classList.add('--active-thumb');
          }
        });
      }
    }
    
    setActiveSplideThumbnail(thumbnail, mediaId) {
      if (!thumbnail) return;
      
      const splide = thumbnail.splide;
      const thumbnailSlide = splide.Components.Slides.filter(`[data-target="${mediaId}"]`)
      
      if(!thumbnailSlide.length) return;

      splide.go(thumbnailSlide[0].index);
    }

    updateVariantStatuses() {
      // Use the admin-order index mapping so availability checks work regardless of whether
      // the Shopify admin option order matches the DOM row order.
      const indices = this.variantOptionIndices || this.options.map((_, i) => i);
      const firstIdx = indices[0] !== undefined ? indices[0] : 0;

      const firstChecked = this.elements.variantsContainer.querySelector(':checked').value;
      const selectedFirstOptionVariants = this.data.variants.filter(variant => {
        if(!variant || !Array.isArray(variant.options)) return false;
        return firstChecked === variant.options[firstIdx];
      });

      const inputWrappers = [...this.variantRows];

      inputWrappers.forEach((option, index) => {
        if (index === 0){
          if(this.currentVariant && this.currentVariant.available){
            this.updateSubmitButton(true, window.variantStrings.addToCart);
          } else{
            this.updateSubmitButton(false, window.variantStrings.soldOut);
          }
          return;
        }

        const optionInputs = [...option.querySelectorAll(this.staticSelectors.inputRadio, this.staticSelectors.option)];
        const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
        const prevIdx = indices[index - 1] !== undefined ? indices[index - 1] : (index - 1);
        const currIdx = indices[index] !== undefined ? indices[index] : index;

        const availableOptionInputsValue = selectedFirstOptionVariants
          .filter(variant => Array.isArray(variant.options) && variant.available && variant.options[prevIdx] === previousOptionSelected)
          .map(variant => variant.options[currIdx]);

        this.setAvailability(optionInputs, availableOptionInputsValue);
      });
    }

    setAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach(input => {
        const label = input.nextElementSibling;
        const labelText = label.querySelector('.label-text-sibling');
        
        if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
          input.classList.remove('disabled');
          labelText.classList.add('hidden');
          labelText.classList.remove('visually-hidden');
        
        } else {
          input.classList.add('disabled');
          labelText.classList.remove('hidden');
          labelText.classList.add('visually-hidden');
        }

        if(this.elements.variantColorsContainer){
          this.onVariantColorChange(true);
        }
      });
    }
    
    setLoaderActivity(checkStatus){
      this.elements.addToCartButton?.forEach((button) => {
        if (!button.querySelector('[data-console-bundle-submit-loader]')) return;

        button.classList.toggle('rq-console-bundle__submit-button--loading', !!checkStatus);
        button.setAttribute('aria-busy', checkStatus ? 'true' : 'false');
      });
      
      if(checkStatus){
        // this.elements.loader.classList.add('--show-loader');
        
        this.elements.loader.forEach(loader => {
          loader.classList.add('--show-loader');
        });
        
        // if(this.elements.inventory) this.elements.inventory.classList.add('--show-loader');
        // if(this.elements.pickUpAvailability) this.elements.pickUpAvailability.classList.add('--show-loader');
        // if(this.elements.priceElem) this.elements.priceElem.classList.add('--show-loader');
        // if(this.elements.saleTag) this.elements.saleTag.classList.add('--show-loader');
        
        this.updateSubmitButton(false);
      } else{
        // this.elements.loader.classList.remove('--show-loader');
        
        this.elements.loader.forEach(loader => {
          loader.classList.remove('--show-loader');
        });
        this.elements.addToCartButton?.forEach((button) => {
          if (button.querySelector('[data-console-bundle-submit-loader]')) button.removeAttribute('aria-busy');
        });
      }
    }
    
    updateSubmitButton(checkStatus, labelText = null){
      if(!this.elements.addToCartButton) return;
      
      if(checkStatus){
        
        this.elements.addToCartButton.forEach(button => {
          button.removeAttribute('disabled');
          button.classList.remove('disabled');
          
          if(labelText && button.querySelector('.button--text')) button.querySelector('.button--text').textContent = labelText;
        });
        
        return;
      }
      
      this.elements.addToCartButton.forEach(button => {
        button.setAttribute('disabled', '');
        button.classList.add('disabled');
        
        if(labelText && button.querySelector('.button--text')) button.querySelector('.button--text').textContent = labelText;
      });
    }

    updateURL() {
      if (!this.dataset.updateUrl) return;
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      if(!this.elements.shareUrlInput) return;
      const shareUrl = `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`;
      this.elements.shareUrlInput.value = shareUrl;
    }
    
    setFromCartUpdates(variantId){
      if(!this.elements.submitFormElem){
        this.elements.cartInvertoryOrganizer.updateBubbleStatus();
        
        return;
      }
      const input = Number(this.elements.submitFormElem.querySelector(this.staticSelectors.inputVariantId));
      if(!input.value || input.value !== variantId) return;
      this.setQtyRules(variantId);
        
      this.elements.cartInvertoryOrganizer.updateBubbleStatus();
    }
    
    getMediaThumbnail(){
      if(!this.currentVariant){
        this.getSelectedVarintOptions();
        this.selectedVariantData();
      }
      
      if (!this.currentVariant || !this.currentVariant.featured_image){
        
        if(this.data.media) return this.data.media[0].preview_image.src;
        
        return this.data.featured_image;
      }
      
      return this.currentVariant.featured_image.src;
    }
    
    getCurrentPriceData(){
      if(!this.currentVariant){
        this.getSelectedVarintOptions();
        this.selectedVariantData();
      }
      
      if (!this.currentVariant) return this.data.price;
      
      return this.currentVariant.price;
    }
  })
}


function initCollapsibleVariantOptions(context) {
  const productData = context.data || null;

  // Auto-select cheapest Version that is compatible with the current Type+Condition selection.
  // We intentionally do NOT use the global cheapest (across all Type/Condition combos) because
  // that could switch to a Version that has no stock for the current standard options, causing
  // an "Unavailable" state on page load.
  if (productData) {
    const advancedFieldsets = Array.from(context.querySelectorAll('fieldset[data-option-name]'));
    if (advancedFieldsets.length > 0) {
      // Build admin-order index mapping (same logic as getSelectedVarintOptions)
      const adminOptions = productData.options || [];
      const advancedNames = advancedFieldsets.map(f => f.dataset.optionName);
      const standardNames = adminOptions.filter(n => !advancedNames.includes(n));
      const domOrderNames = [...standardNames, ...advancedNames];
      const domToAdminIndices = domOrderNames.map(name => adminOptions.indexOf(name));
      const standardAdminIndices = domToAdminIndices.slice(0, standardNames.length);

      // Read which standard options (Type, Condition) are currently selected
      const allRows = Array.from(context.querySelectorAll('product-card-variants .js-contents--variant-row'));
      const standardRows = allRows.filter(row => !advancedFieldsets.some(f => f.contains(row)));
      const currentStandardValues = standardRows.map(row => {
        const checked = row.querySelector('input[type="radio"]:checked');
        return checked ? checked.value : null;
      });

      // Narrow to variants that are available AND match the current standard selections
      // using the correct admin-order indices (not DOM positional indices)
      const compatibleVariants = productData.variants.filter(v =>
        v.available && currentStandardValues.every((val, idx) =>
          val === null || val === v.options[standardAdminIndices[idx]]
        )
      );

      // For each advanced option fieldset, pick the cheapest compatible value
      advancedFieldsets.forEach((fieldset) => {
        const optionName = fieldset.dataset.optionName;
        const optionIndex = adminOptions.indexOf(optionName);
        if (optionIndex === -1) return;

        const priceByValue = {};
        compatibleVariants.forEach(v => {
          const val = v.options[optionIndex];
          if (priceByValue[val] === undefined || v.price < priceByValue[val]) {
            priceByValue[val] = v.price;
          }
        });

        if (Object.keys(priceByValue).length === 0) return;

        const cheapestVal = Object.entries(priceByValue).sort(([, a], [, b]) => a - b)[0][0];
        const target = fieldset.querySelector(`input[type="radio"][value="${CSS.escape(cheapestVal)}"]`);
        if (target && !target.checked) {
          target.checked = true;
          target.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }
  }

  // Toggle button for the advanced options panel
  context.querySelectorAll('.advanced-options-toggle').forEach(btn => {
    const panelId = btn.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    const label = btn.querySelector('.advanced-options-toggle-label');
    if (!panel) return;

    btn.addEventListener('click', () => {
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!isOpen));
      panel.hidden = isOpen;
      if (label) label.textContent = isOpen ? 'Show advanced options' : 'Hide advanced options';
    });
  });

  if (window.initProductInfoTooltips) {
    window.initProductInfoTooltips(context);
  }
}

function expandVariantRow(summary, pills) {
  // Cancel any in-flight collapse that would re-hide the panel
  if (pills._collapseAbort) { pills._collapseAbort.abort(); pills._collapseAbort = null; }
  pills.hidden = false;
  // Double-RAF: first frame renders the element at max-height:0, second triggers the transition
  requestAnimationFrame(() => requestAnimationFrame(() => pills.classList.add('is-open')));
  summary.setAttribute('aria-expanded', 'true');
}

function collapseVariantRow(summary, pills) {
  // Cancel any previous collapse listener before starting a new one
  if (pills._collapseAbort) pills._collapseAbort.abort();
  pills.classList.remove('is-open');
  summary.setAttribute('aria-expanded', 'false');
  const ac = new AbortController();
  pills._collapseAbort = ac;
  pills.addEventListener('transitionend', () => {
    pills.hidden = true;
    pills._collapseAbort = null;
  }, { once: true, signal: ac.signal });
}

if (!customElements.get('bundle-product-wrapper')) {
  customElements.define('bundle-product-wrapper', class BundleProductWrapper extends HTMLElement {
    constructor() {
      super();
      
      this.elements = {
        submitButton: this.querySelector('.bundle-cart-sbumit'),
        cartShower: document.querySelector('[data-action="cart-drawer"]'),
        cartInvertoryOrganizer: document.querySelector('cart-inventory-organizer'),
        priceContainer: document.querySelector('.bundle-price'),
        comparePriceContainer: document.querySelector('.bundle-compare-price'),
        thumbsListContainer: this.querySelector('.fbt-items-list')
      }
      
      this.elements.submitButton.addEventListener('click', this.onSubmit.bind(this));

      subscribe(PUB_SUB_EVENTS.variantChange, (data) => {
        // Only react to the main product card (not cards inside this bundle wrapper)
        if (this.contains(data.source)) return;

        const CONDITION_VALUES = ['ex', 'vg', 'fa', 'po', 'sp', 'new'];
        const conditionIndex = data.options.findIndex(opt => CONDITION_VALUES.includes(opt));
        if (conditionIndex === -1) return;

        this.syncBundleCondition(data.options[conditionIndex]);
      });
    }

    syncBundleCondition(conditionValue) {
      this.querySelectorAll('product-card').forEach(card => {
        const rows = card.querySelectorAll('product-card-variants .variant-row');
        rows.forEach(row => {
          const radio = row.querySelector(`input[type="radio"][value="${conditionValue}"]`);
          if (radio && !radio.checked) radio.click();
        });
      });
    }

    onSubmit(){
      event.preventDefault();
      const productCards = this.querySelectorAll('product-card');
      
      if(productCards){
        const cardsArr = Array.from(productCards);
        
        this.bundleSubmit(cardsArr);
      }
    }
    
    bundleSubmit(productCards){
      if(productCards.length){
        const cardCurr = productCards[0];
        
        if(cardCurr.dataset.bundleIncluded === 'false'){
          this.setCurrentStatuses(productCards);
          
          return;
        }
        this.elements.submitButton.classList.add('--show-loader');
        
        const form = cardCurr.querySelector('form');
        form.removeEventListener('submit', cardCurr.onsubmitHandler);
        form.addEventListener('bundlesubmit', this.addToCartCard(form, productCards));
        
        const submitEvent = new Event('bundlesubmit', { bubbles: true, cancelable: true });
        form.dispatchEvent(submitEvent);
        
        return;
      }
      
      this.elements.submitButton.classList.remove('disabled');
      this.elements.submitButton.classList.remove('--show-loader');
      
      this.elements.cartInvertoryOrganizer.updateBubbleStatus();
      this.showCartShower();
    }
    
    addToCartCard(dataForm, cards){    
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      
      const formData = new FormData(dataForm);
      formData.append('sections', this.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      
      fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        this.getSectionsToRender().forEach((section => {
          const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
          sectionElement.innerHTML = this.getSectionInnerHTML(response.sections[section.id], section.selector);
        }));
        
        const cartItemQty = response.quantity;
        this.elements.cartInvertoryOrganizer.setCartUpdates(cartItemQty);
      })
      .catch((e) => {
        console.error(e);
      }).finally(() => {
        this.setCurrentStatuses(cards);
      });
    }
    
    setCurrentStatuses(products){
      const cardCurr = products[0];
      cardCurr.setAttribute('data-bundle-added', true);
      
      const nextCardsArr = products.slice(1);
      this.bundleSubmit(nextCardsArr);
    }
    
    showCartShower(){
      if(this.elements.cartShower) this.elements.cartShower.open();
    }
    
    getSectionsToRender() {
      return [
        {
          id: 'cart-inventory-organizer',
          section: 'cart-inventory-organizer',
          selector: 'cart-inventory-organizer'
        },
        {
          id: 'cart-items',
          selector: '#cart-items',
          section: 'cart-items'
        }
      ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser() .parseFromString(html, 'text/html') .querySelector(selector).innerHTML;
    }
    
    resetThumbsList(){
      while(this.elements.thumbsListContainer.firstChild){
        this.elements.thumbsListContainer.removeChild(this.elements.thumbsListContainer.firstChild);
      }
    }
    
    initBundleCheck(){
      const bundleCards = this.querySelectorAll('product-card');
      
      if(bundleCards.length){
        let setButton = false;
        let bundlePrice = 0;
        let bundleComparePrice = 0;
        const bundleCounterWrapper = this.querySelector('.bcs-counter-wrap');
        const bundleCount = bundleCounterWrapper.querySelector('.bcs-count');
        let count = bundleCards.length;
        
        this.resetThumbsList();
        
        bundleCards.forEach(product => {              
          if(product.dataset.bundleIncluded === 'true'){
            const mediaThumb = product.getMediaThumbnail();
            const thumbItem = document.createElement("li");
            if(mediaThumb) thumbItem.style.backgroundImage = `url('${mediaThumb}')`;
            this.elements.thumbsListContainer.appendChild(thumbItem);
            bundlePrice += product.currentVariant ? product.currentVariant.price : product.data.price;
            
            if(product.currentVariant){
              bundleComparePrice += product.currentVariant.compare_at_price ? product.currentVariant.compare_at_price : product.currentVariant.price;
              
            } else{
              bundleComparePrice += product.data.compare_at_price ? product.data.compare_at_price : product.data.price;
            }
            
            setButton = true;
            if(setButton) this.elements.submitButton.classList.remove('disabled');
          }
          
          if(product.dataset.bundleIncluded === 'false'){
            count--;
          }
        });
        
        this.elements.priceContainer.innerText = Shopify.formatMoney(bundlePrice, window.money_format);
        
        if(bundleComparePrice > bundlePrice){
          this.elements.comparePriceContainer.classList.remove('hidden');
          this.elements.comparePriceContainer.innerText = Shopify.formatMoney(bundleComparePrice, window.money_format);
        
        } else{
          this.elements.comparePriceContainer.classList.add('hidden');
          this.elements.comparePriceContainer.innerText = Shopify.formatMoney(0, window.money_format);
        }
        
        if(count > 0){
          bundleCount.innerText = count;
          bundleCounterWrapper.classList.remove('hidden');
        
        } else{
          bundleCount.innerText = 0;
          bundleCounterWrapper.classList.add('hidden');
          this.elements.submitButton.classList.add('disabled');
        }
        
        this.classList.remove('visually-hidden');
        this.querySelector('.fbt-products-block_sidewrap').classList.remove('visually-hidden');
      }
    }
  })
}

if (!customElements.get('product-compare-button')) {
  customElements.define('product-compare-button', class ProductCompareButton extends HTMLElement {
    constructor() {
      super();
      
      this.anchor = this.querySelector('a') ? this.querySelector('a') : this.querySelector('button');
      this.anchor.addEventListener('click', this.onCompare.bind(this));
    }
    
    connectedCallback(){
      this.checkComparelistStatus();
    }
    
    onCompare(){
      event.preventDefault();
      if(!this.dataset.handle) return;
      
      const handle = this.dataset.handle;
      const compareListStorage = localStorage.getItem('comparelist');
      const comparelistContainer = document.querySelector('[data-modal-main="compare"]');
      const comparelistOrganizer = document.querySelector('.compare-counter');
      let compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
      const compareLimit = 3;
      
      if(!compareList.includes(handle)){
      
        if(compareList.length && compareList.length >= compareLimit){
          comparelistContainer.classList.add('--limit-exceed');
          
          alert(window.additionalStrings.compare.limitExceed);
          return;
        
        } else{
          compareList.push(handle);
          comparelistContainer.classList.remove('--limit-exceed');
        }
      
      } else{
        var index = compareList.indexOf(handle);
        
        if (index !== -1) {
          compareList.splice(index, 1);
        }
      }
      localStorage.setItem('comparelist', JSON.stringify(compareList));
      
      const modalOpener = document.querySelector('[data-modal-main="compare"]');

      if(compareList.length === 0){
        modalOpener.classList.add('hidden');
      
      } else if(compareList.length === 1){
        modalOpener.classList.remove('hidden');
        modalOpener.classList.add('--disabled');
      
      } else{
        modalOpener.classList.remove('--disabled');
        modalOpener.classList.remove('hidden');
      }
      
      if(comparelistOrganizer){
        comparelistOrganizer.innerText = compareList.length;
      }
      
      this.checkComparelistStatus();
    }
    
    checkComparelistStatus(){
      if(!this.dataset.handle) return;
      
      const allBtns = document.querySelectorAll('product-compare-button');
      const compareListStorage = localStorage.getItem('comparelist');
      const compareList = compareListStorage ? JSON.parse(compareListStorage) : [];
      
      allBtns.forEach(btn => {
        const handle = btn.dataset.handle;
        const anchor = btn.querySelector('a');
        const text = btn.querySelector('.pwb-text');
        
        if(compareList.includes(handle)){
          anchor.classList.add('--compare-active');
          text.innerHTML = window.accessibilityStrings.compareRemovebutton.replace('[product_name]', btn.dataset.product);
        
        } else{
          anchor.classList.remove('--compare-active');
          text.innerHTML = window.accessibilityStrings.compareAddbutton.replace('[product_name]', btn.dataset.product);
        }
      });
    }
  })
}


// ── Gallery track height: adapt to each image's rendered height ───────
(function() {
  var MAIN_SLIDER_SELECTOR = '.main-thumb-slider';
  var TRACK_SELECTOR = '.splide__track';
  var LIST_SELECTOR = '.splide__list';
  var ACTIVE_SLIDE_SELECTOR = '.splide__slide.is-active';
  var THUMBNAIL_SELECTOR = '.product-gallery-thumbnail';

  function getNumber(value) {
    var parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function getActiveSlide(mainSlider) {
    return mainSlider.querySelector(ACTIVE_SLIDE_SELECTOR) || mainSlider.querySelector('.splide__slide');
  }

  function applyGalleryHeight(mainSlider, animate) {
    if (!mainSlider) return;

    var track = mainSlider.querySelector(TRACK_SELECTOR);
    var slide = getActiveSlide(mainSlider);
    if (!track || !slide) return;

    var thumbnail = slide.querySelector(THUMBNAIL_SELECTOR);
    var img = thumbnail ? thumbnail.querySelector('img') : null;
    if (!thumbnail || !img || !img.complete || !img.naturalWidth) return;

    var imgRect = img.getBoundingClientRect();
    if (!imgRect.height) return;

    var thumbStyles = window.getComputedStyle(thumbnail);
    var totalH = Math.ceil(
      imgRect.height +
      getNumber(thumbStyles.paddingTop) +
      getNumber(thumbStyles.paddingBottom)
    );

    track.style.transition = animate ? 'height 0.4s ease' : 'none';
    track.style.setProperty('height', totalH + 'px', 'important');
  }

  function scheduleApply(mainSlider, animate) {
    window.requestAnimationFrame(function() {
      applyGalleryHeight(mainSlider, animate);
    });
  }

  function bindImageLoad(mainSlider, img) {
    if (!img || img.dataset.rqGalleryHeightImageBound) return;

    img.addEventListener('load', function() {
      scheduleApply(mainSlider, true);
    });
    img.dataset.rqGalleryHeightImageBound = 'true';
  }

  function initMainSlider(mainSlider) {
    if (!mainSlider || mainSlider.dataset.rqGalleryHeightBound) return;

    var list = mainSlider.querySelector(LIST_SELECTOR);
    if (!list) return;

    mainSlider.querySelectorAll(THUMBNAIL_SELECTOR + ' img').forEach(function(img) {
      bindImageLoad(mainSlider, img);
    });

    var mutationObserver = new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var el = mutations[i].target;
        if (!el.classList || !el.classList.contains('splide__slide') || !el.classList.contains('is-active')) continue;

        var img = el.querySelector(THUMBNAIL_SELECTOR + ' img');
        bindImageLoad(mainSlider, img);
        scheduleApply(mainSlider, true);
        break;
      }
    });

    mutationObserver.observe(list, { attributes: true, attributeFilter: ['class'], subtree: true });

    if ('ResizeObserver' in window) {
      var resizeObserver = new ResizeObserver(function() {
        scheduleApply(mainSlider, false);
      });
      resizeObserver.observe(mainSlider);
    }

    mainSlider.dataset.rqGalleryHeightBound = 'true';
    scheduleApply(mainSlider, false);

    var attempts = 0;
    var poll = window.setInterval(function() {
      attempts++;
      scheduleApply(mainSlider, false);
      if (attempts >= 10) window.clearInterval(poll);
    }, 100);
  }

  function init() {
    document.querySelectorAll(MAIN_SLIDER_SELECTOR).forEach(initMainSlider);
  }

  function applyAll(animate) {
    document.querySelectorAll(MAIN_SLIDER_SELECTOR).forEach(function(mainSlider) {
      scheduleApply(mainSlider, animate);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', function() {
    init();
    applyAll(false);
  }, { passive: true });
  document.addEventListener('shopify:section:load', init);
})();
